// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Roboto:wght@300;400;500;700&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `html,
body {
  height: 100%;
}

.font-size-1 {
  font-size: 1px !important;
}

.font-size-2 {
  font-size: 2px !important;
}

.font-size-3 {
  font-size: 3px !important;
}

.font-size-4 {
  font-size: 4px !important;
}

.font-size-5 {
  font-size: 5px !important;
}

.font-size-6 {
  font-size: 6px !important;
}

.font-size-7 {
  font-size: 7px !important;
}

.font-size-8 {
  font-size: 8px !important;
}

.font-size-9 {
  font-size: 9px !important;
}

.font-size-10 {
  font-size: 10px !important;
}

.font-size-11 {
  font-size: 11px !important;
}

.font-size-12 {
  font-size: 12px !important;
}

.font-size-13 {
  font-size: 13px !important;
}

.font-size-14 {
  font-size: 14px !important;
}

.font-size-15 {
  font-size: 15px !important;
}

.font-size-16 {
  font-size: 16px !important;
}

.font-size-17 {
  font-size: 17px !important;
}

.font-size-18 {
  font-size: 18px !important;
}

.font-size-19 {
  font-size: 19px !important;
}

.font-size-20 {
  font-size: 20px !important;
}

.font-size-21 {
  font-size: 21px !important;
}

.font-size-22 {
  font-size: 22px !important;
}

.font-size-23 {
  font-size: 23px !important;
}

.font-size-24 {
  font-size: 24px !important;
}

.font-size-25 {
  font-size: 25px !important;
}

.font-size-26 {
  font-size: 26px !important;
}

.font-size-27 {
  font-size: 27px !important;
}

.font-size-28 {
  font-size: 28px !important;
}

.font-size-29 {
  font-size: 29px !important;
}

.font-size-30 {
  font-size: 30px !important;
}

.font-size-31 {
  font-size: 31px !important;
}

.font-size-32 {
  font-size: 32px !important;
}

.font-size-33 {
  font-size: 33px !important;
}

.font-size-34 {
  font-size: 34px !important;
}

.font-size-35 {
  font-size: 35px !important;
}

.font-size-36 {
  font-size: 36px !important;
}

.font-size-37 {
  font-size: 37px !important;
}

.font-size-38 {
  font-size: 38px !important;
}

.font-size-39 {
  font-size: 39px !important;
}

.font-size-40 {
  font-size: 40px !important;
}

.font-size-41 {
  font-size: 41px !important;
}

.font-size-42 {
  font-size: 42px !important;
}

.font-size-43 {
  font-size: 43px !important;
}

.font-size-44 {
  font-size: 44px !important;
}

.font-size-45 {
  font-size: 45px !important;
}

.font-size-46 {
  font-size: 46px !important;
}

.font-size-47 {
  font-size: 47px !important;
}

.font-size-48 {
  font-size: 48px !important;
}

.font-size-49 {
  font-size: 49px !important;
}

.font-size-50 {
  font-size: 50px !important;
}

.font-size-51 {
  font-size: 51px !important;
}

.font-size-52 {
  font-size: 52px !important;
}

.font-size-53 {
  font-size: 53px !important;
}

.font-size-54 {
  font-size: 54px !important;
}

.font-size-55 {
  font-size: 55px !important;
}

.font-size-56 {
  font-size: 56px !important;
}

.font-size-57 {
  font-size: 57px !important;
}

.font-size-58 {
  font-size: 58px !important;
}

.font-size-59 {
  font-size: 59px !important;
}

.font-size-60 {
  font-size: 60px !important;
}

.font-size-61 {
  font-size: 61px !important;
}

.font-size-62 {
  font-size: 62px !important;
}

.font-size-63 {
  font-size: 63px !important;
}

.font-size-64 {
  font-size: 64px !important;
}

.font-size-65 {
  font-size: 65px !important;
}

.font-size-66 {
  font-size: 66px !important;
}

.font-size-67 {
  font-size: 67px !important;
}

.font-size-68 {
  font-size: 68px !important;
}

.font-size-69 {
  font-size: 69px !important;
}

.font-size-70 {
  font-size: 70px !important;
}

.font-size-71 {
  font-size: 71px !important;
}

.font-size-72 {
  font-size: 72px !important;
}

.font-size-73 {
  font-size: 73px !important;
}

.font-size-74 {
  font-size: 74px !important;
}

.font-size-75 {
  font-size: 75px !important;
}

.font-size-76 {
  font-size: 76px !important;
}

.font-size-77 {
  font-size: 77px !important;
}

.font-size-78 {
  font-size: 78px !important;
}

.font-size-79 {
  font-size: 79px !important;
}

.font-size-80 {
  font-size: 80px !important;
}

.font-size-81 {
  font-size: 81px !important;
}

.font-size-82 {
  font-size: 82px !important;
}

.font-size-83 {
  font-size: 83px !important;
}

.font-size-84 {
  font-size: 84px !important;
}

.font-size-85 {
  font-size: 85px !important;
}

.font-size-86 {
  font-size: 86px !important;
}

.font-size-87 {
  font-size: 87px !important;
}

.font-size-88 {
  font-size: 88px !important;
}

.font-size-89 {
  font-size: 89px !important;
}

.font-size-90 {
  font-size: 90px !important;
}

.font-size-91 {
  font-size: 91px !important;
}

.font-size-92 {
  font-size: 92px !important;
}

.font-size-93 {
  font-size: 93px !important;
}

.font-size-94 {
  font-size: 94px !important;
}

.font-size-95 {
  font-size: 95px !important;
}

.font-size-96 {
  font-size: 96px !important;
}

.font-size-97 {
  font-size: 97px !important;
}

.font-size-98 {
  font-size: 98px !important;
}

.font-size-99 {
  font-size: 99px !important;
}

.font-size-100 {
  font-size: 100px !important;
}

body {
  margin: 0;
  font-family: "roboto" !important;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  background-color: hsl(0, 0%, 92%) !important;
  color: hsl(217, 24%, 17%) !important;
}

a {
  color: hsl(240, 91%, 69%);
}
a:hover, a:focus {
  color: hsl(240, 91%, 69%);
}
a.no-underline {
  text-decoration: none;
}

.cursor-pointer {
  cursor: pointer;
}

.custom_animation_show #actions-menu {
  width: 0;
}
.custom_animation_show #actions-menu .MuiBackdrop-invisible {
  width: 0 !important;
}

.tile {
  background: white;
  width: 25%;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-right: 1px;
}
.tile span {
  color: hsla(214, 4%, 31%, 0.8);
  line-height: 1.08;
  padding: 2px 0px;
  white-space: nowrap;
  position: relative;
}
.tile span:before {
  background-color: hsl(233, 100%, 57%);
  bottom: -14.8px;
  content: "";
  height: 2px;
  left: 0px;
  opacity: 0;
  position: absolute;
  right: 0px;
  transform-origin: left center;
  transform: scaleX(0);
  transition: all 250ms cubic-bezier(0.25, 0.46, 0.45, 0.94) 0s;
  visibility: hidden;
  width: auto;
}

.STILE .tab {
  color: hsl(233, 100%, 57%);
}
.STILE span:before {
  transform: scaleX(1.1);
  visibility: visible;
  opacity: 1 !important;
}

.drawer__container {
  background-color: hsla(240, 50%, 4%, 0.69);
}
.drawer__container .header_container {
  position: relative;
}
.drawer__container .MuiPaper-root {
  width: 100%;
  background-color: #fafafa;
}
.drawer__container .MuiPaper-root .MuiBox-root {
  z-index: 2;
}
.drawer__container .drawer__body .drawer__tabs {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0px 72px 0px 35px;
  border: 1px solid #EDEDED;
}
.drawer__container .drawer__body .drawer__tabs .tabs__container {
  width: 40%;
  background: transparent;
  height: 100%;
  margin: 0;
  padding: 0;
  display: flex;
}
.drawer__container .drawer__body .drawer__tabs span.drawer__tabsOptions {
  cursor: pointer;
  font-weight: 400;
  font-size: 16px;
}

.drawer__container .drawer__body .drawer__tabs_content {
  display: none;
  padding-right: 1rem;
  max-height: calc(100vh - 11em);
  overflow-y: auto;
  scrollbar-width: 0;
  scrollbar-color: hsla(240, 100%, 34%, 0.29) #fff;
}
.drawer__container .drawer__body .drawer__tabs_content::-webkit-scrollbar {
  width: 0;
  height: 0;
  margin-right: -1em;
  background-color: #fff;
}
.drawer__container .drawer__body .drawer__tabs_content::-webkit-scrollbar-thumb {
  background-color: hsla(240, 100%, 34%, 0.29);
  border-radius: 3px;
}
.drawer__container .drawer__body .drawer__tabs_content::-webkit-scrollbar-thumb:hover {
  background-color: hsla(240, 100%, 44%, 0.39);
}

.drawer__container .drawer__body.drawer__tabs_config_active .drawer__tabs_content.drawer__tabs_configContent, .drawer__tabs_performanceContent {
  display: block;
  padding-left: 1px;
}
.drawer__container .drawer__body.drawer__tabs_config_active .drawer__tabs_content.drawer__tabs_configContent .indi__error, .drawer__tabs_performanceContent .indi__error {
  color: hsl(5, 99%, 64%);
  font-size: 12px;
  font-weight: 300;
  letter-spacing: 0.15px;
  margin-top: 5px;
}
.drawer__container .drawer__body.drawer__tabs_config_active .drawer__tabs_content.drawer__tabs_configContent .sticky__header, .drawer__tabs_performanceContent .sticky__header {
  position: sticky;
  top: 0;
  z-index: 1;
}
.drawer__container .drawer__body.drawer__tabs_config_active .drawer__tabs_content.drawer__tabs_configContent .sticky__header .cta__header, .drawer__tabs_performanceContent .sticky__header .cta__header {
  justify-content: space-between;
  align-items: flex-start;
  background: hsl(0, 0%, 100%);
  padding: 12px 17px 12px 23px;
  border-radius: 5px;
  border-bottom: 1px solid #F5F5F5;
  margin-top: 58px;
}
.drawer__container .drawer__body.drawer__tabs_config_active .drawer__tabs_content.drawer__tabs_configContent .sticky__header .cta__header .action_cta, .drawer__tabs_performanceContent .sticky__header .cta__header .action_cta {
  flex: 1 1;
  padding-right: 10px;
}
.drawer__container .drawer__body.drawer__tabs_config_active .drawer__tabs_content.drawer__tabs_configContent .sticky__header .cta__header .action_cta p, .drawer__tabs_performanceContent .sticky__header .cta__header .action_cta p {
  margin-bottom: 0;
  font-weight: 400;
  font-size: 12px;
  text-transform: capitalize;
}
.drawer__container .drawer__body.drawer__tabs_config_active .drawer__tabs_content.drawer__tabs_configContent .sticky__header .cta__header .action_cta .drawer__body-entity, .drawer__tabs_performanceContent .sticky__header .cta__header .action_cta .drawer__body-entity {
  margin-top: 0;
}
.drawer__container .drawer__body.drawer__tabs_config_active .drawer__tabs_content.drawer__tabs_configContent .sticky__header .cta__header .cta__button .save__btn, .drawer__tabs_performanceContent .sticky__header .cta__header .cta__button .save__btn {
  background-color: hsl(234, 95%, 92%);
  color: hsl(234, 92%, 56%);
  border: none;
}
.drawer__container .drawer__body.drawer__tabs_config_active .drawer__tabs_content.drawer__tabs_configContent .sticky__header .cta__header .cta__button .dynamic__btn, .drawer__tabs_performanceContent .sticky__header .cta__header .cta__button .dynamic__btn {
  background-color: hsl(233, 100%, 57%);
  font-weight: 600;
  color: hsl(0, 0%, 100%);
  border: none;
  margin-right: 6px;
}
.drawer__container .drawer__body.drawer__tabs_config_active .drawer__tabs_content.drawer__tabs_configContent .sticky__header .cta__header .cta__button button, .drawer__tabs_performanceContent .sticky__header .cta__header .cta__button button {
  font-weight: 500;
  font-size: 14px;
  letter-spacing: 0.25px;
  padding: 2px 36px;
  border-radius: 5px;
  text-transform: capitalize;
  box-shadow: none;
}
.drawer__container .drawer__body.drawer__tabs_config_active .drawer__tabs_content.drawer__tabs_configContent .sticky__header .cta__header .cta__button button:first-child, .drawer__tabs_performanceContent .sticky__header .cta__header .cta__button button:first-child {
  margin-right: 17px;
}
.drawer__container .drawer__body.drawer__tabs_config_active .drawer__tabs_content.drawer__tabs_configContent .sticky__header .cta__header .cta__button .setting__btn, .drawer__tabs_performanceContent .sticky__header .cta__header .cta__button .setting__btn {
  width: 34px;
}
.drawer__container .drawer__body.drawer__tabs_config_active .drawer__tabs_content.drawer__tabs_configContent .sticky__header .cta__header .cta__button button:disabled,
.drawer__container .drawer__body.drawer__tabs_config_active .drawer__tabs_content.drawer__tabs_configContent .sticky__header .cta__header .cta__button button[disabled], .drawer__tabs_performanceContent .sticky__header .cta__header .cta__button button:disabled,
.drawer__tabs_performanceContent .sticky__header .cta__header .cta__button button[disabled] {
  border: none;
  background-color: hsl(0, 0%, 92%);
  color: hsl(0, 0%, 77%);
}
.drawer__container .drawer__body.drawer__tabs_config_active .drawer__tabs_content.drawer__tabs_configContent .sticky__header .cta__header .cta__button svg, .drawer__tabs_performanceContent .sticky__header .cta__header .cta__button svg {
  stroke-width: 0.7px;
}
.drawer__container .drawer__body.drawer__tabs_config_active .drawer__tabs_content.drawer__tabs_configContent .sticky__header .date__data, .drawer__tabs_performanceContent .sticky__header .date__data {
  background: hsl(0, 0%, 100%);
  padding: 12px 17px 12px 23px;
  border-radius: 5px;
  justify-content: space-between;
}
.drawer__container .drawer__body.drawer__tabs_config_active .drawer__tabs_content.drawer__tabs_configContent .sticky__header .date__data .drawer__body__data__label, .drawer__tabs_performanceContent .sticky__header .date__data .drawer__body__data__label {
  text-transform: inherit;
  min-width: auto;
}
.drawer__container .drawer__body.drawer__tabs_config_active .drawer__tabs_content.drawer__tabs_configContent .sticky__header .date__data .drawer__body__data__value, .drawer__tabs_performanceContent .sticky__header .date__data .drawer__body__data__value {
  color: hsl(223, 4%, 66%);
  margin-left: 3px;
}
.drawer__container .drawer__body.drawer__tabs_config_active .drawer__tabs_content.drawer__tabs_configContent .sticky__header .date__data .d-flex.left, .drawer__tabs_performanceContent .sticky__header .date__data .d-flex.left {
  width: 395px;
  justify-content: space-between;
  align-items: center;
}
.drawer__container .drawer__body.drawer__tabs_config_active .drawer__tabs_content.drawer__tabs_configContent .sticky__header .date__data .d-flex.left p, .drawer__tabs_performanceContent .sticky__header .date__data .d-flex.left p {
  text-transform: capitalize;
  margin-bottom: 0;
}
.drawer__container .drawer__body.drawer__tabs_config_active .drawer__tabs_content.drawer__tabs_configContent .sticky__header .date__data .d-flex.left .line, .drawer__tabs_performanceContent .sticky__header .date__data .d-flex.left .line {
  color: hsl(223, 4%, 66%);
  width: 1px;
}

.drawer__container .drawer__body.drawer__tabs_apiIntegration_active .drawer__tabs_content.drawer__tabs_apiInteContent {
  display: block;
  height: 75vh;
  overflow: hidden;
  padding-top: 1.5rem;
}

.drawer__container .drawer__body.drawer__tabs_performance_active .drawer__tabs_content.drawer__tabs_performanceContent {
  display: block;
}

.input-width-0 {
  box-sizing: content-box;
  width: 1ch;
}

.input-width-1 {
  box-sizing: content-box;
  width: 1ch;
}

.input-width-2 {
  box-sizing: content-box;
  width: 2ch;
}

.input-width-3 {
  box-sizing: content-box;
  width: 3ch;
}

.input-width-4 {
  box-sizing: content-box;
  width: 4ch;
}

.input-width-5 {
  box-sizing: content-box;
  width: 5ch;
}

.input-width-6 {
  box-sizing: content-box;
  width: 6ch;
}

.input-width-7 {
  box-sizing: content-box;
  width: 7ch;
}

.input-width-8 {
  box-sizing: content-box;
  width: 8ch;
}

.input-width-9 {
  box-sizing: content-box;
  width: 9ch;
}

.input-width-10 {
  box-sizing: content-box;
  width: 10ch;
}

.input-width-11 {
  box-sizing: content-box;
  width: 11ch;
}

.input-width-12 {
  box-sizing: content-box;
  width: 12ch;
}

.input-width-13 {
  box-sizing: content-box;
  width: 13ch;
}

.input-width-14 {
  box-sizing: content-box;
  width: 14ch;
}

.input-width-15 {
  box-sizing: content-box;
  width: 15ch;
}

.input-width-16 {
  box-sizing: content-box;
  width: 16ch;
}

.input-width-17 {
  box-sizing: content-box;
  width: 17ch;
}

.input-width-18 {
  box-sizing: content-box;
  width: 18ch;
}

.input-width-19 {
  box-sizing: content-box;
  width: 19ch;
}

.input-width-20 {
  box-sizing: content-box;
  width: 20ch;
}

.input-width-21 {
  box-sizing: content-box;
  width: 21ch;
}

.input-width-22 {
  box-sizing: content-box;
  width: 22ch;
}

.input-width-23 {
  box-sizing: content-box;
  width: 23ch;
}

.input-width-24 {
  box-sizing: content-box;
  width: 24ch;
}

.input-width-25 {
  box-sizing: content-box;
  width: 25ch;
}

.input-width-26 {
  box-sizing: content-box;
  width: 26ch;
}

.input-width-27 {
  box-sizing: content-box;
  width: 27ch;
}

.input-width-28 {
  box-sizing: content-box;
  width: 28ch;
}

.input-width-29 {
  box-sizing: content-box;
  width: 29ch;
}

.input-width-30 {
  box-sizing: content-box;
  width: 30ch;
}

.input-width-31 {
  box-sizing: content-box;
  width: 31ch;
}

.input-width-32 {
  box-sizing: content-box;
  width: 32ch;
}

.input-width-33 {
  box-sizing: content-box;
  width: 33ch;
}

.input-width-34 {
  box-sizing: content-box;
  width: 34ch;
}

.input-width-35 {
  box-sizing: content-box;
  width: 35ch;
}

.input-width-36 {
  box-sizing: content-box;
  width: 36ch;
}

.input-width-37 {
  box-sizing: content-box;
  width: 37ch;
}

.input-width-38 {
  box-sizing: content-box;
  width: 38ch;
}

.input-width-39 {
  box-sizing: content-box;
  width: 39ch;
}

.input-width-40 {
  box-sizing: content-box;
  width: 40ch;
}

.input-width-41 {
  box-sizing: content-box;
  width: 41ch;
}

.input-width-42 {
  box-sizing: content-box;
  width: 42ch;
}

.input-width-43 {
  box-sizing: content-box;
  width: 43ch;
}

.input-width-44 {
  box-sizing: content-box;
  width: 44ch;
}

.input-width-45 {
  box-sizing: content-box;
  width: 45ch;
}

.input-width-46 {
  box-sizing: content-box;
  width: 46ch;
}

.input-width-47 {
  box-sizing: content-box;
  width: 47ch;
}

.input-width-48 {
  box-sizing: content-box;
  width: 48ch;
}

.input-width-49 {
  box-sizing: content-box;
  width: 49ch;
}

.input-width-50 {
  box-sizing: content-box;
  width: 50ch;
}

.input-width-51 {
  box-sizing: content-box;
  width: 51ch;
}

.input-width-52 {
  box-sizing: content-box;
  width: 52ch;
}

.input-width-53 {
  box-sizing: content-box;
  width: 53ch;
}

.input-width-54 {
  box-sizing: content-box;
  width: 54ch;
}

.input-width-55 {
  box-sizing: content-box;
  width: 55ch;
}

.input-width-56 {
  box-sizing: content-box;
  width: 56ch;
}

.input-width-57 {
  box-sizing: content-box;
  width: 57ch;
}

.input-width-58 {
  box-sizing: content-box;
  width: 58ch;
}

.input-width-59 {
  box-sizing: content-box;
  width: 59ch;
}

.input-width-60 {
  box-sizing: content-box;
  width: 60ch;
}

.input-width-61 {
  box-sizing: content-box;
  width: 61ch;
}

.input-width-62 {
  box-sizing: content-box;
  width: 62ch;
}

.input-width-63 {
  box-sizing: content-box;
  width: 63ch;
}

.input-width-64 {
  box-sizing: content-box;
  width: 64ch;
}

.input-width-65 {
  box-sizing: content-box;
  width: 65ch;
}

.input-width-66 {
  box-sizing: content-box;
  width: 66ch;
}

.input-width-67 {
  box-sizing: content-box;
  width: 67ch;
}

.input-width-68 {
  box-sizing: content-box;
  width: 68ch;
}

.input-width-69 {
  box-sizing: content-box;
  width: 69ch;
}

.input-width-70 {
  box-sizing: content-box;
  width: 70ch;
}

.input-width-71 {
  box-sizing: content-box;
  width: 71ch;
}

.input-width-72 {
  box-sizing: content-box;
  width: 72ch;
}

.input-width-73 {
  box-sizing: content-box;
  width: 73ch;
}

.input-width-74 {
  box-sizing: content-box;
  width: 74ch;
}

.input-width-75 {
  box-sizing: content-box;
  width: 75ch;
}

.input-width-76 {
  box-sizing: content-box;
  width: 76ch;
}

.input-width-77 {
  box-sizing: content-box;
  width: 77ch;
}

.input-width-78 {
  box-sizing: content-box;
  width: 78ch;
}

.input-width-79 {
  box-sizing: content-box;
  width: 79ch;
}

.input-width-80 {
  box-sizing: content-box;
  width: 80ch;
}

.input-width-81 {
  box-sizing: content-box;
  width: 81ch;
}

.input-width-82 {
  box-sizing: content-box;
  width: 82ch;
}

.input-width-83 {
  box-sizing: content-box;
  width: 83ch;
}

.input-width-84 {
  box-sizing: content-box;
  width: 84ch;
}

.input-width-85 {
  box-sizing: content-box;
  width: 85ch;
}

.input-width-86 {
  box-sizing: content-box;
  width: 86ch;
}

.input-width-87 {
  box-sizing: content-box;
  width: 87ch;
}

.input-width-88 {
  box-sizing: content-box;
  width: 88ch;
}

.input-width-89 {
  box-sizing: content-box;
  width: 89ch;
}

.input-width-90 {
  box-sizing: content-box;
  width: 90ch;
}

.input-width-91 {
  box-sizing: content-box;
  width: 91ch;
}

.input-width-92 {
  box-sizing: content-box;
  width: 92ch;
}

.input-width-93 {
  box-sizing: content-box;
  width: 93ch;
}

.input-width-94 {
  box-sizing: content-box;
  width: 94ch;
}

.input-width-95 {
  box-sizing: content-box;
  width: 95ch;
}

.input-width-96 {
  box-sizing: content-box;
  width: 96ch;
}

.input-width-97 {
  box-sizing: content-box;
  width: 97ch;
}

.input-width-98 {
  box-sizing: content-box;
  width: 98ch;
}

.input-width-99 {
  box-sizing: content-box;
  width: 99ch;
}

.input-width-100 {
  box-sizing: content-box;
  width: 100ch;
}

.drawer__header {
  background-color: hsl(0, 0%, 96%);
  height: 50px;
  padding: 0 3rem;
  color: white;
}
.drawer__header__button__icon svg {
  font-weight: 900;
}

.drawer__body-subtitle {
  color: hsl(223, 4%, 66%);
  font-weight: 400;
  font-size: 12px;
}

.drawer__header-close {
  cursor: pointer;
  display: flex;
  align-items: center;
}
.drawer__header-close svg {
  margin-right: 9px;
}
.drawer__header-close p {
  color: #233dff;
  font-weight: 400;
  margin-bottom: 0;
  font-size: 16px;
}

.drawer__header-btn {
  background-color: #DC22FF;
  color: white;
  border-radius: 4px;
}

.drawer__body {
  background-color: #fafafa;
}
.drawer__body__variations__allocation-btn {
  font-size: 12px !important;
  font-weight: 500 !important;
  padding: 1px 20px !important;
  text-transform: inherit !important;
  border-width: 1px !important;
  border: 1px solid #D5D9FE !important;
  color: hsl(233, 100%, 57%) !important;
  height: 27px;
}
.drawer__body__variations__allocation-btn.active {
  background-color: hsl(0, 0%, 100%);
  border-color: hsl(0, 0%, 100%) !important;
  border-radius: 4px 4px 0px 0px;
}
.drawer__body__variations__allocation-menu .MuiPaper-root {
  min-width: 286px !important;
  box-shadow: none !important;
  padding-bottom: 0.2em;
  background-color: hsl(0, 0%, 100%) !important;
  margin-top: -2px !important;
}
.drawer__body__variations__allocation-menu ul {
  background-color: hsl(0, 0%, 100%);
}
.drawer__body__variations__allocation-menu ul .MuiMenuItem-root {
  border: none !important;
  padding: 0 0.9rem !important;
}
.drawer__body__variations__allocation-menu ul .MuiMenuItem-root .innerList {
  padding: 0.5em 0 !important;
  color: hsl(232, 8%, 64%);
  border-bottom: 1px solid hsl(0, 0%, 92%) !important;
  font-size: 8px;
}
.drawer__body__variations__allocation-menu ul .MuiMenuItem-root .innerList .innerWrapper {
  width: 100%;
  padding: 0 !important;
}
.drawer__body__variations__allocation-menu ul .MuiMenuItem-root .innerList .innerWrapper span {
  padding-left: 4px;
}
.drawer__body__variations__allocation-menu ul .MuiMenuItem-root .innerList .innerWrapper.active {
  background-color: hsla(237, 69%, 40%, 0.06);
}
.drawer__body__variations__allocation-menu ul .MuiMenuItem-root:hover .innerList {
  background-color: transparent !important;
}
.drawer__body__variations__allocation-menu ul .MuiMenuItem-root:hover .innerList .innerWrapper {
  background-color: hsla(237, 69%, 40%, 0.06);
}
.drawer__body__variations .slider__container {
  display: flex;
  align-items: center;
  margin-top: 18px;
  margin-bottom: 22px;
}
.drawer__body__success {
  padding: 7px 11px 9px 10px;
  font-size: 12px;
  position: fixed;
  bottom: 1.5em;
  left: 2.5em;
  width: 322px;
  word-break: inherit;
  background-color: hsl(217, 24%, 17%);
  border-radius: 0;
  border-left: 4px solid #00B481;
  box-shadow: 0px 4px 4px rgba(196, 196, 196, 0.57);
  z-index: 1400;
}
.drawer__body__success .header__msg {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 15px;
}
.drawer__body__success.error {
  border-left: 4px solid #E10000;
}
.drawer__body__success .success_icon_msg {
  font-weight: 700;
  font-size: 12px;
  color: #FDFDFD;
  letter-spacing: 0.15px;
}
.drawer__body__success .success-msg {
  margin: 0;
  font-weight: 300;
  font-size: 12px;
  color: #FDFDFD;
  letter-spacing: 0.15px;
  margin-bottom: 13px;
  overflow: hidden;
}
.drawer__body__success .success-close {
  font-weight: 400;
  font-size: 12px;
  color: #FDFDFD;
  letter-spacing: 0.15px;
  text-decoration: underline;
  cursor: pointer;
}
.drawer__body__entity.bottom__field {
  padding-bottom: 18px;
}
.drawer__body__entity.bottom__field:last-child {
  padding-bottom: 0;
}
.drawer__body__entity.bottom__field:not(:last-child) {
  border-bottom: 1px solid #E9E9E9;
}
.drawer__body__entity.bottom__field:not(:first-child) {
  margin-top: 18px;
}
.drawer__body__entity__title {
  color: hsl(217, 31%, 6%);
  font-weight: bold;
  font-size: 11px;
  line-height: 24px;
  letter-spacing: 0.15px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.drawer__body__entity__title.error {
  color: hsl(5, 99%, 64%);
}
.drawer__body__entity__title__label {
  font-size: 12px;
  font-weight: 700;
  color: hsl(214, 4%, 39%);
  min-width: 4.5rem;
  text-align: left;
  letter-spacing: 0.15px;
}
.drawer__body__entity__title__label.error {
  color: hsl(5, 99%, 64%);
}
.drawer__body__entity__title__id {
  font-size: 12px;
  font-weight: 700;
  color: #a5a7ac;
  padding: 0 19px 0 27px;
  text-align: left;
  max-width: 127px;
  min-width: 127px;
  text-align: center;
}
.drawer__body__entity__title__traffic {
  font-weight: 400;
  font-size: 11px;
  background: transparent;
  color: #000;
  min-width: 105px;
  text-align: center;
  border-radius: 5px;
  border: 1px solid #ECECED;
}
.drawer__body__entity__title__traffic.error__input__variation {
  border: 1px solid hsl(5, 99%, 64%);
}
.drawer__body__entity__title__traffic__input {
  width: 1.75rem;
  text-align: center;
  padding: 0;
  background: transparent;
  border: none;
  outline: none;
  -moz-appearance: textfield;
}
.drawer__body__entity__title__traffic__input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
.drawer__body__entity__title__desc {
  padding: 0px 8px;
  font-weight: 400;
  font-size: 11px;
  letter-spacing: 0.15px;
  color: #AFB1B6;
  border: 1px solid #ECECED;
  border-radius: 5px;
  max-width: 544px;
  white-space: nowrap;
  margin-left: 8px;
  width: 100%;
  overflow: hidden;
}
.drawer__body__entity__title__desc.error__input__variation {
  border: 1px solid hsl(5, 99%, 64%);
}
.drawer__body__entity__title__desc__input {
  width: 100%;
  text-align: left;
  padding: 0;
  background: transparent;
  border: none;
  outline: none;
  -moz-appearance: textfield;
}
.drawer__body__entity__title__desc__input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
.drawer__body__entity__title__json {
  padding: 0px 8px;
  font-weight: 400;
  font-size: 11px;
  letter-spacing: 0.15px;
  color: #AFB1B6;
  border: 1px solid #ECECED;
  border-radius: 5px;
  max-width: 544px;
  white-space: nowrap;
  margin-left: 8px;
  width: 100%;
  overflow: hidden;
}
.drawer__body__entity__title__json.error {
  border: 1px solid hsl(5, 99%, 64%);
}
.drawer__body__entity__title__jsonBtn {
  font-weight: 500 !important;
  font-size: 12px !important;
  background-color: transparent !important;
  border: 1px solid hsl(234, 95%, 92%) !important;
  padding: 0px 25px !important;
  box-shadow: none !important;
  color: hsl(233, 100%, 57%) !important;
  margin-left: 8px !important;
  line-height: inherit !important;
}
.drawer__body__entity__title__copyBtn {
  margin-left: 14px;
}
.drawer__body__entity__title .delete__btn {
  font-weight: 400;
  text-transform: capitalize;
  font-size: 12px;
  padding: 0 !important;
  line-height: 1;
  min-width: 0;
  border: 0;
  text-decoration: underline;
  margin-left: 16px;
}
.drawer__body__entity__title .delete__btn:hover {
  background-color: transparent;
  border: 0;
  text-decoration: underline;
}
.drawer__body__entity__title span text {
  margin-left: 0.5em;
  margin-right: 0.5em;
}
.drawer__body__entity__form {
  display: flex;
  align-items: center;
  flex-grow: 1;
  margin-right: 21px;
}
.drawer__body__entity__form__control {
  background-color: transparent;
  height: 27px;
  flex-grow: 1;
  width: 414px;
  padding-left: 10px;
  padding-right: 7px;
  display: flex;
  align-items: center;
  border-radius: 5px 0px 0px 5px;
  border: 1px solid rgba(140, 145, 152, 0.13);
}
.drawer__body__entity__form__control .MuiSlider-colorPrimary {
  background-color: hsl(234, 95%, 92%);
  background-image: none;
}
.drawer__body__entity__form__control .MuiSlider-thumbColorPrimary {
  background-color: hsl(233, 100%, 57%) !important;
}
.drawer__body__entity__form__code {
  border: 2px solid hsla(214, 4%, 39%, 0.63);
  border-radius: 4px;
  width: 100%;
  resize: vertical;
  height: 100%;
}
.drawer__body__entity__form__code.error {
  border: 2px solid hsl(5, 100%, 69%) !important;
}
.drawer__body__entity__form__code .ace_scrollbar {
  width: 5px !important;
}
.drawer__body__entity__form__code .ace_editor {
  width: 100% !important;
  height: 100% !important;
}
.drawer__body__entity__form__code .ace_editor .ace_print-margin {
  width: 0;
}
.drawer__body__entity__form__code .ace-xcode .ace_print-margin {
  display: none;
}
.drawer__body__entity__form__label {
  background-color: transparent;
  letter-spacing: 0.15px;
  height: 27px;
  min-width: 106px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 500;
  font-size: 11px;
  border: 1px solid rgba(140, 145, 152, 0.13);
  border-radius: 0px 5px 5px 0px;
  line-height: 0;
}
.drawer__body__entity__form__button {
  margin-left: 0.15em;
  display: flex;
}
.drawer__body__entity__form__button button {
  padding: 0.3em;
  font-size: 8px;
  line-height: 16px;
  letter-spacing: 0.25px;
}
.drawer__body__entity__form__button button.hide {
  visibility: hidden;
  pointer-events: none;
}

.drawer__body__data {
  display: flex;
  align-items: center;
  margin-right: 1rem;
  min-width: 9rem;
  overflow: hidden;
}
.drawer__body__data.gate_id {
  min-width: fit-content;
  margin-right: 18px;
}
.drawer__body__data.gate_id .drawer__body__data__value {
  margin-left: 0.2rem;
  color: hsl(223, 4%, 66%);
  font-weight: 700;
}
.drawer__body__data.gate_id .drawer__body__data__label {
  min-width: min-content;
  color: hsl(223, 4%, 66%);
  font-weight: 700;
  text-transform: capitalize;
}
.drawer__body__data.api_integration {
  color: hsl(223, 4%, 66%);
  font-weight: 400;
  text-decoration: underline;
  font-size: 12px;
  cursor: pointer;
}
.drawer__body__data__label {
  font-weight: bold;
  font-size: 12px;
  line-height: 16px;
  text-transform: uppercase;
  letter-spacing: 0.4px;
  color: hsla(217, 24%, 17%, 0.35);
  min-width: 4.5rem;
}
.drawer__body__data__value {
  font-weight: normal;
  font-size: 12px;
  line-height: 30px;
  letter-spacing: 0.15px;
  color: hsl(217, 31%, 6%);
  margin-left: 0.5rem;
}

.drawer__body-entity {
  display: flex;
  align-items: center;
  border: none;
  border-radius: 5px;
  margin-top: 2px;
  padding-right: 10px;
}
.drawer__body-entity:hover svg {
  opacity: 1;
}
.drawer__body-entity svg {
  opacity: 0;
}
.drawer__body-entity:focus-within svg {
  display: none;
}
.drawer__body-entity.error {
  box-shadow: 0 0 0.05rem 0.05rem hsl(5, 100%, 69%);
}

.drawer__body-input {
  background-color: transparent !important;
  border: none;
  border-radius: 5px;
  font-size: 20px;
  font-weight: 700;
  letter-spacing: 0.15px;
  padding-top: 0;
  padding-bottom: 0;
  color: hsl(214, 4%, 31%) !important;
  padding-left: 0;
}
.drawer__body-input:focus {
  box-shadow: none;
  border: none !important;
}
.drawer__body-input.error {
  box-shadow: 0 0 0.05rem 0.05rem hsl(5, 100%, 69%);
}

.drawer__body-entity_title_inner {
  font-size: 10px;
  color: white;
  opacity: 1;
}

.drawer__error {
  color: red;
  font-size: 12px;
  text-align: center;
}

.drawer__body-variation_btn {
  width: 100%;
  color: #A4A6AB !important;
  font-weight: 500;
  font-size: 14px;
  letter-spacing: 0.25px !important;
  text-transform: inherit !important;
  padding: 6px 0 !important;
  background-color: #Fafafa !important;
  border-color: none !important;
  box-shadow: none !important;
}

.drawer__body-remove_btn {
  color: white;
  font-size: 10px;
}

.drawer__body-container {
  padding: 22px 47px 64px 25px;
  background: #ffffff;
  border-radius: 10px;
}
.drawer__body-container .drawer__body-title {
  font-size: 15px;
  font-weight: 400;
  margin-bottom: 9px;
}

.drawer_body__entity__container {
  margin-top: 26px;
  border: 1px solid #E9E9E9;
  padding: 18px 36px 21px 11px;
  border-radius: 5px;
}

.jsonForm-dialog .MuiPaper-root {
  max-width: inherit;
  width: 100%;
  height: 637px;
}
.jsonForm-dialog .MuiPaper-root .jsonForm__content {
  width: 100%;
  height: 637px;
  padding: 18px 32px 30px 40px;
}
.jsonForm-dialog .MuiPaper-root .jsonForm__content .indi__error {
  color: hsl(5, 99%, 64%);
  font-size: 12px;
  font-weight: 300;
  letter-spacing: 0.15px;
  margin-top: 5px;
  margin-bottom: 8px;
}
.jsonForm-dialog .MuiPaper-root .jsonForm__content .jsonPopUp__header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.jsonForm-dialog .MuiPaper-root .jsonForm__content .jsonPopUp__header p {
  font-weight: 600;
  font-size: 15px;
  margin: 0;
}
.jsonForm-dialog .MuiPaper-root .jsonForm__content .jsonPopUp__header button {
  background: #ffffff;
  padding: 1px 34px;
  border: 1px solid #d5d9fe;
  border-radius: 5px;
  color: hsl(233, 100%, 57%);
  letter-spacing: 0.25px;
  font-weight: 500;
  font-size: 14px;
}
.jsonForm-dialog .MuiPaper-root .jsonForm__content .jsonPopUp__header .save__btn {
  background-color: hsl(233, 100%, 57%);
  font-weight: 600;
  color: hsl(0, 0%, 100%);
  box-shadow: none;
  padding: 1px 34px;
  border: 1px solid hsl(233, 100%, 57%);
  line-height: inherit;
  margin-left: 12px;
  text-transform: capitalize;
}
.jsonForm-dialog .MuiPaper-root .jsonForm__content .jsonPopUp__header .save__btn.Mui-disabled {
  background-color: hsl(0, 0%, 92%) !important;
  border: 1px solid hsl(0, 0%, 92%);
  color: hsl(0, 0%, 77%);
}
.jsonForm-dialog .MuiPaper-root .jsonForm__content .json__subtitle {
  font-weight: 400;
  font-size: 12px;
  letter-spacing: 0.25px;
  color: hsl(223, 4%, 66%);
  margin-bottom: 14px;
}
.jsonForm-dialog .MuiPaper-root .jsonForm__content .drawer__body__entity__form {
  height: 517px;
  margin-right: 0;
}

.drawer__tabs_performanceContent .performance__footer__container {
  background-color: hsl(0, 0%, 100%);
  padding: 29px 21px 16px 22px;
  border-radius: 10px;
  height: 600px;
}
.drawer__tabs_performanceContent .performance__footer__container .drawer__body-title {
  font-weight: 400;
  font-size: 15px;
  color: hsl(214, 4%, 31%);
}
.drawer__tabs_performanceContent .performance__footer__container .drawer__body-subtitle {
  color: hsl(223, 4%, 66%);
  margin-top: 9px;
}
.drawer__tabs_performanceContent .performance__footer__container .drawer__footer .e-input-group.e-control-wrapper {
  background-color: #F9F9FA !important;
  border-radius: 4px !important;
  font-weight: 400;
  font-size: 12px;
  border: 1px solid hsla(0, 0%, 75%, 0.28) !important;
}

.indi__error {
  color: hsl(5, 99%, 64%);
  font-size: 12px;
  font-weight: 300;
  letter-spacing: 0.15px;
  margin-top: 5px;
  margin-bottom: 8px;
}

.indi__error.variation {
  margin-bottom: 0;
}

.confirmSave_popup .MuiPaper-root {
  max-width: 488px;
  padding: 40px 29px 30px 28px;
  background-color: hsl(0, 0%, 95%);
}
.confirmSave_popup .MuiPaper-root .confirm__save__content {
  padding: 0;
}
.confirmSave_popup .MuiPaper-root .confirm__save__content .confirm__save .confirmSave__cta {
  margin-top: 34px;
  text-align: center;
}
.confirmSave_popup .MuiPaper-root .confirm__save__content .confirm__save .confirmSave__cta button {
  font-weight: 600;
  font-size: 14px;
}
.confirmSave_popup .MuiPaper-root .confirm__save__content .confirm__save .confirmSave__cta button:focus {
  outline: none;
  box-shadow: none;
}
.confirmSave_popup .MuiPaper-root .confirm__save__content .confirm__save .confirmSave__cta button:first-child {
  background: #ffffff;
  border: 1px solid #D5D9FE;
  color: #233dff;
  padding: 4px 36px;
  margin-right: 13px;
}
.confirmSave_popup .MuiPaper-root .confirm__save__content .confirm__save .confirmSave__cta .save__btn {
  background-color: #233dff;
  border: 1px solid #233dff !important;
  color: #ffffff !important;
  text-transform: capitalize;
  padding: 3px 40px;
  height: 100%;
  line-height: inherit;
}
.confirmSave_popup .MuiPaper-root p {
  font-weight: 500;
  font-size: 20px;
  color: hsla(214, 4%, 31%, 0.79);
}

.drawer__body.drawer__tabs_performance_active .cta__button button {
  font-weight: 500;
  font-size: 14px;
  letter-spacing: 0.25px;
  padding: 2px 36px;
  border-radius: 5px;
  text-transform: capitalize;
  box-shadow: none;
}
.drawer__body.drawer__tabs_performance_active .cta__button button svg.dots {
  width: 15px;
  height: 26px;
  fill: black;
  stroke-width: 1.5px;
}

.archive__msg, .archiveBlank__msg {
  display: none;
}`, "",{"version":3,"sources":["webpack://./src/index.scss","webpack://./src/components/forms/gates/gates.scss"],"names":[],"mappings":"AAyDA;;EAEE,YAAA;ACvDF;;AD6DE;EACI,yBAAA;AC1DN;;ADyDE;EACI,yBAAA;ACtDN;;ADqDE;EACI,yBAAA;AClDN;;ADiDE;EACI,yBAAA;AC9CN;;AD6CE;EACI,yBAAA;AC1CN;;ADyCE;EACI,yBAAA;ACtCN;;ADqCE;EACI,yBAAA;AClCN;;ADiCE;EACI,yBAAA;AC9BN;;AD6BE;EACI,yBAAA;AC1BN;;ADyBE;EACI,0BAAA;ACtBN;;ADqBE;EACI,0BAAA;AClBN;;ADiBE;EACI,0BAAA;ACdN;;ADaE;EACI,0BAAA;ACVN;;ADSE;EACI,0BAAA;ACNN;;ADKE;EACI,0BAAA;ACFN;;ADCE;EACI,0BAAA;ACEN;;ADHE;EACI,0BAAA;ACMN;;ADPE;EACI,0BAAA;ACUN;;ADXE;EACI,0BAAA;ACcN;;ADfE;EACI,0BAAA;ACkBN;;ADnBE;EACI,0BAAA;ACsBN;;ADvBE;EACI,0BAAA;AC0BN;;AD3BE;EACI,0BAAA;AC8BN;;AD/BE;EACI,0BAAA;ACkCN;;ADnCE;EACI,0BAAA;ACsCN;;ADvCE;EACI,0BAAA;AC0CN;;AD3CE;EACI,0BAAA;AC8CN;;AD/CE;EACI,0BAAA;ACkDN;;ADnDE;EACI,0BAAA;ACsDN;;ADvDE;EACI,0BAAA;AC0DN;;AD3DE;EACI,0BAAA;AC8DN;;AD/DE;EACI,0BAAA;ACkEN;;ADnEE;EACI,0BAAA;ACsEN;;ADvEE;EACI,0BAAA;AC0EN;;AD3EE;EACI,0BAAA;AC8EN;;AD/EE;EACI,0BAAA;ACkFN;;ADnFE;EACI,0BAAA;ACsFN;;ADvFE;EACI,0BAAA;AC0FN;;AD3FE;EACI,0BAAA;AC8FN;;AD/FE;EACI,0BAAA;ACkGN;;ADnGE;EACI,0BAAA;ACsGN;;ADvGE;EACI,0BAAA;AC0GN;;AD3GE;EACI,0BAAA;AC8GN;;AD/GE;EACI,0BAAA;ACkHN;;ADnHE;EACI,0BAAA;ACsHN;;ADvHE;EACI,0BAAA;AC0HN;;AD3HE;EACI,0BAAA;AC8HN;;AD/HE;EACI,0BAAA;ACkIN;;ADnIE;EACI,0BAAA;ACsIN;;ADvIE;EACI,0BAAA;AC0IN;;AD3IE;EACI,0BAAA;AC8IN;;AD/IE;EACI,0BAAA;ACkJN;;ADnJE;EACI,0BAAA;ACsJN;;ADvJE;EACI,0BAAA;AC0JN;;AD3JE;EACI,0BAAA;AC8JN;;AD/JE;EACI,0BAAA;ACkKN;;ADnKE;EACI,0BAAA;ACsKN;;ADvKE;EACI,0BAAA;AC0KN;;AD3KE;EACI,0BAAA;AC8KN;;AD/KE;EACI,0BAAA;ACkLN;;ADnLE;EACI,0BAAA;ACsLN;;ADvLE;EACI,0BAAA;AC0LN;;AD3LE;EACI,0BAAA;AC8LN;;AD/LE;EACI,0BAAA;ACkMN;;ADnME;EACI,0BAAA;ACsMN;;ADvME;EACI,0BAAA;AC0MN;;AD3ME;EACI,0BAAA;AC8MN;;AD/ME;EACI,0BAAA;ACkNN;;ADnNE;EACI,0BAAA;ACsNN;;ADvNE;EACI,0BAAA;AC0NN;;AD3NE;EACI,0BAAA;AC8NN;;AD/NE;EACI,0BAAA;ACkON;;ADnOE;EACI,0BAAA;ACsON;;ADvOE;EACI,0BAAA;AC0ON;;AD3OE;EACI,0BAAA;AC8ON;;AD/OE;EACI,0BAAA;ACkPN;;ADnPE;EACI,0BAAA;ACsPN;;ADvPE;EACI,0BAAA;AC0PN;;AD3PE;EACI,0BAAA;AC8PN;;AD/PE;EACI,0BAAA;ACkQN;;ADnQE;EACI,0BAAA;ACsQN;;ADvQE;EACI,0BAAA;AC0QN;;AD3QE;EACI,0BAAA;AC8QN;;AD/QE;EACI,0BAAA;ACkRN;;ADnRE;EACI,0BAAA;ACsRN;;ADvRE;EACI,0BAAA;AC0RN;;AD3RE;EACI,0BAAA;AC8RN;;AD/RE;EACI,0BAAA;ACkSN;;ADnSE;EACI,0BAAA;ACsSN;;ADvSE;EACI,0BAAA;AC0SN;;AD3SE;EACI,0BAAA;AC8SN;;AD/SE;EACI,0BAAA;ACkTN;;ADnTE;EACI,0BAAA;ACsTN;;ADvTE;EACI,0BAAA;AC0TN;;AD3TE;EACI,0BAAA;AC8TN;;AD/TE;EACI,0BAAA;ACkUN;;ADnUE;EACI,0BAAA;ACsUN;;ADvUE;EACI,0BAAA;AC0UN;;AD3UE;EACI,0BAAA;AC8UN;;AD/UE;EACI,2BAAA;ACkVN;;AD9UA;EACE,SAAA;EACA,gCAAA;EACA,mCAAA;EACA,kCAAA;EACA,4CAAA;EACA,oCAAA;ACiVF;;AD9UA;EACE,yBA9Ca;AC+Xf;AD/UE;EAEE,yBAnDW;ACmYf;AD7UE;EACE,qBAAA;AC+UJ;;AD3UA;EACE,eAAA;AC8UF;;AAjaI;EACI,QAAA;AAoaR;AAnaS;EACG,mBAAA;AAqaZ;;AA/ZA;EACI,iBAAA;EACA,UAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,iBAAA;AAkaJ;AAjaI;EACI,8BDgBO;ECbP,iBAAA;EACA,gBAAA;EACA,mBAAA;EACA,kBAAA;AAiaR;AAhaQ;EACE,qCD5BQ;EC6BR,eAAA;EACA,WAAA;EACA,WAAA;EACA,SAAA;EACA,UAAA;EACA,kBAAA;EACA,UAAA;EACA,6BAAA;EACA,oBAAA;EACA,6DAAA;EACA,kBAAA;EACA,WAAA;AAkaV;;AA1ZI;EACI,0BDjDU;AC8clB;AA3ZI;EACI,sBAAA;EACA,mBAAA;EACA,qBAAA;AA6ZR;;AAxZA;EACI,0CD9CY;ACychB;AA1ZI;EACI,kBAAA;AA4ZR;AAzZI;EACI,WAAA;EAEA,yBAAA;AA0ZR;AAzZQ;EACI,UAAA;AA2ZZ;AAxZI;EACI,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,0BAAA;EACA,yBAAA;AA0ZR;AAzZQ;EACI,UAAA;EACA,uBAAA;EACA,YAAA;EACA,SAAA;EACA,UAAA;EACA,aAAA;AA2ZZ;AAxZI;EACI,eAAA;EACA,gBAAA;EACA,eAAA;AA0ZR;;AArZA;EACI,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,gBAAA;EACA,kBAAA;EACA,gDAAA;AAwZJ;AAtZI;EAGI,QAAA;EACA,SAAA;EACA,kBAAA;EACA,sBAAA;AAsZR;AAnZM;EACE,4CAAA;EACA,kBAAA;AAqZR;AAnZQ;EACI,4CAAA;AAqZZ;;AA/YA;EACI,cAAA;EACA,iBAAA;AAkZJ;AAjZI;EACI,uBDrIS;ECsIT,eAAA;EACA,gBAAA;EACA,sBAAA;EACA,eAAA;AAmZR;AAjZI;EACI,gBAAA;EACA,MAAA;EACA,UAAA;AAmZR;AAlZI;EACI,8BAAA;EACA,uBAAA;EACA,4BDlIQ;ECmIR,4BAAA;EACA,kBAAA;EACA,gCAAA;EAEA,gBAAA;AAmZR;AAlZQ;EACI,SAAA;EACA,mBAAA;AAoZZ;AAnZY;EACI,gBAAA;EACA,gBAAA;EACA,eAAA;EACA,0BAAA;AAqZhB;AAnZY;EACI,aAAA;AAqZhB;AAjZY;EACI,oCDxHC;ECyHD,yBDxHD;ECyHC,YAAA;AAmZhB;AAjZY;EACI,qCDvKE;ECwKF,gBAAA;EACA,uBD9JA;EC+JA,YAAA;EACA,iBAAA;AAmZhB;AAjZY;EACI,gBAAA;EACA,eAAA;EACA,sBAAA;EACA,iBAAA;EACA,kBAAA;EACA,0BAAA;EACA,gBAAA;AAmZhB;AA/YgB;EACI,kBAAA;AAiZpB;AA9YY;EACI,WAAA;AAgZhB;AA9YY;;;EAEA,YAAA;EACA,iCD5LI;EC6LJ,sBD9JG;AC+iBf;AA/YY;EACI,mBAAA;AAiZhB;AA7YI;EACI,4BDhMQ;ECiMR,4BAAA;EACA,kBAAA;EACA,8BAAA;AA+YR;AA9YQ;EACI,uBAAA;EACA,eAAA;AAgZZ;AA9YQ;EACI,wBDpLG;ECqLH,gBAAA;AAgZZ;AA9YQ;EACI,YAAA;EACA,8BAAA;EACA,mBAAA;AAgZZ;AA/YY;EACI,0BAAA;EACA,gBAAA;AAiZhB;AA/YY;EACI,wBDhMD;ECiMC,UAAA;AAiZhB;;AA1YA;EACI,cAAA;EACA,YAAA;EACA,gBAAA;EACA,mBAAA;AA6YJ;;AA1YA;EACI,cAAA;AA6YJ;;AAzYA;EACI,uBAAA;EACA,UAAA;AA4YJ;;AAtYI;EACI,uBAAA;EACA,UAJI;AA6YZ;;AA3YI;EACI,uBAAA;EACA,UAJI;AAkZZ;;AAhZI;EACI,uBAAA;EACA,UAJI;AAuZZ;;AArZI;EACI,uBAAA;EACA,UAJI;AA4ZZ;;AA1ZI;EACI,uBAAA;EACA,UAJI;AAiaZ;;AA/ZI;EACI,uBAAA;EACA,UAJI;AAsaZ;;AApaI;EACI,uBAAA;EACA,UAJI;AA2aZ;;AAzaI;EACI,uBAAA;EACA,UAJI;AAgbZ;;AA9aI;EACI,uBAAA;EACA,UAJI;AAqbZ;;AAnbI;EACI,uBAAA;EACA,WAJI;AA0bZ;;AAxbI;EACI,uBAAA;EACA,WAJI;AA+bZ;;AA7bI;EACI,uBAAA;EACA,WAJI;AAocZ;;AAlcI;EACI,uBAAA;EACA,WAJI;AAycZ;;AAvcI;EACI,uBAAA;EACA,WAJI;AA8cZ;;AA5cI;EACI,uBAAA;EACA,WAJI;AAmdZ;;AAjdI;EACI,uBAAA;EACA,WAJI;AAwdZ;;AAtdI;EACI,uBAAA;EACA,WAJI;AA6dZ;;AA3dI;EACI,uBAAA;EACA,WAJI;AAkeZ;;AAheI;EACI,uBAAA;EACA,WAJI;AAueZ;;AAreI;EACI,uBAAA;EACA,WAJI;AA4eZ;;AA1eI;EACI,uBAAA;EACA,WAJI;AAifZ;;AA/eI;EACI,uBAAA;EACA,WAJI;AAsfZ;;AApfI;EACI,uBAAA;EACA,WAJI;AA2fZ;;AAzfI;EACI,uBAAA;EACA,WAJI;AAggBZ;;AA9fI;EACI,uBAAA;EACA,WAJI;AAqgBZ;;AAngBI;EACI,uBAAA;EACA,WAJI;AA0gBZ;;AAxgBI;EACI,uBAAA;EACA,WAJI;AA+gBZ;;AA7gBI;EACI,uBAAA;EACA,WAJI;AAohBZ;;AAlhBI;EACI,uBAAA;EACA,WAJI;AAyhBZ;;AAvhBI;EACI,uBAAA;EACA,WAJI;AA8hBZ;;AA5hBI;EACI,uBAAA;EACA,WAJI;AAmiBZ;;AAjiBI;EACI,uBAAA;EACA,WAJI;AAwiBZ;;AAtiBI;EACI,uBAAA;EACA,WAJI;AA6iBZ;;AA3iBI;EACI,uBAAA;EACA,WAJI;AAkjBZ;;AAhjBI;EACI,uBAAA;EACA,WAJI;AAujBZ;;AArjBI;EACI,uBAAA;EACA,WAJI;AA4jBZ;;AA1jBI;EACI,uBAAA;EACA,WAJI;AAikBZ;;AA/jBI;EACI,uBAAA;EACA,WAJI;AAskBZ;;AApkBI;EACI,uBAAA;EACA,WAJI;AA2kBZ;;AAzkBI;EACI,uBAAA;EACA,WAJI;AAglBZ;;AA9kBI;EACI,uBAAA;EACA,WAJI;AAqlBZ;;AAnlBI;EACI,uBAAA;EACA,WAJI;AA0lBZ;;AAxlBI;EACI,uBAAA;EACA,WAJI;AA+lBZ;;AA7lBI;EACI,uBAAA;EACA,WAJI;AAomBZ;;AAlmBI;EACI,uBAAA;EACA,WAJI;AAymBZ;;AAvmBI;EACI,uBAAA;EACA,WAJI;AA8mBZ;;AA5mBI;EACI,uBAAA;EACA,WAJI;AAmnBZ;;AAjnBI;EACI,uBAAA;EACA,WAJI;AAwnBZ;;AAtnBI;EACI,uBAAA;EACA,WAJI;AA6nBZ;;AA3nBI;EACI,uBAAA;EACA,WAJI;AAkoBZ;;AAhoBI;EACI,uBAAA;EACA,WAJI;AAuoBZ;;AAroBI;EACI,uBAAA;EACA,WAJI;AA4oBZ;;AA1oBI;EACI,uBAAA;EACA,WAJI;AAipBZ;;AA/oBI;EACI,uBAAA;EACA,WAJI;AAspBZ;;AAppBI;EACI,uBAAA;EACA,WAJI;AA2pBZ;;AAzpBI;EACI,uBAAA;EACA,WAJI;AAgqBZ;;AA9pBI;EACI,uBAAA;EACA,WAJI;AAqqBZ;;AAnqBI;EACI,uBAAA;EACA,WAJI;AA0qBZ;;AAxqBI;EACI,uBAAA;EACA,WAJI;AA+qBZ;;AA7qBI;EACI,uBAAA;EACA,WAJI;AAorBZ;;AAlrBI;EACI,uBAAA;EACA,WAJI;AAyrBZ;;AAvrBI;EACI,uBAAA;EACA,WAJI;AA8rBZ;;AA5rBI;EACI,uBAAA;EACA,WAJI;AAmsBZ;;AAjsBI;EACI,uBAAA;EACA,WAJI;AAwsBZ;;AAtsBI;EACI,uBAAA;EACA,WAJI;AA6sBZ;;AA3sBI;EACI,uBAAA;EACA,WAJI;AAktBZ;;AAhtBI;EACI,uBAAA;EACA,WAJI;AAutBZ;;AArtBI;EACI,uBAAA;EACA,WAJI;AA4tBZ;;AA1tBI;EACI,uBAAA;EACA,WAJI;AAiuBZ;;AA/tBI;EACI,uBAAA;EACA,WAJI;AAsuBZ;;AApuBI;EACI,uBAAA;EACA,WAJI;AA2uBZ;;AAzuBI;EACI,uBAAA;EACA,WAJI;AAgvBZ;;AA9uBI;EACI,uBAAA;EACA,WAJI;AAqvBZ;;AAnvBI;EACI,uBAAA;EACA,WAJI;AA0vBZ;;AAxvBI;EACI,uBAAA;EACA,WAJI;AA+vBZ;;AA7vBI;EACI,uBAAA;EACA,WAJI;AAowBZ;;AAlwBI;EACI,uBAAA;EACA,WAJI;AAywBZ;;AAvwBI;EACI,uBAAA;EACA,WAJI;AA8wBZ;;AA5wBI;EACI,uBAAA;EACA,WAJI;AAmxBZ;;AAjxBI;EACI,uBAAA;EACA,WAJI;AAwxBZ;;AAtxBI;EACI,uBAAA;EACA,WAJI;AA6xBZ;;AA3xBI;EACI,uBAAA;EACA,WAJI;AAkyBZ;;AAhyBI;EACI,uBAAA;EACA,WAJI;AAuyBZ;;AAryBI;EACI,uBAAA;EACA,WAJI;AA4yBZ;;AA1yBI;EACI,uBAAA;EACA,WAJI;AAizBZ;;AA/yBI;EACI,uBAAA;EACA,WAJI;AAszBZ;;AApzBI;EACI,uBAAA;EACA,WAJI;AA2zBZ;;AAzzBI;EACI,uBAAA;EACA,WAJI;AAg0BZ;;AA9zBI;EACI,uBAAA;EACA,WAJI;AAq0BZ;;AAn0BI;EACI,uBAAA;EACA,WAJI;AA00BZ;;AAx0BI;EACI,uBAAA;EACA,WAJI;AA+0BZ;;AA70BI;EACI,uBAAA;EACA,WAJI;AAo1BZ;;AAl1BI;EACI,uBAAA;EACA,WAJI;AAy1BZ;;AAv1BI;EACI,uBAAA;EACA,WAJI;AA81BZ;;AA51BI;EACI,uBAAA;EACA,WAJI;AAm2BZ;;AAj2BI;EACI,uBAAA;EACA,WAJI;AAw2BZ;;AAt2BI;EACI,uBAAA;EACA,WAJI;AA62BZ;;AA32BI;EACI,uBAAA;EACA,WAJI;AAk3BZ;;AAh3BI;EACI,uBAAA;EACA,WAJI;AAu3BZ;;AAr3BI;EACI,uBAAA;EACA,YAJI;AA43BZ;;AAp3BA;EAEI,iCAAA;EACA,YAAA;EACA,eAAA;EACA,YAAA;AAs3BJ;AAp3BI;EACI,gBAAA;AAs3BR;;AAl3BA;EACI,wBD/OW;ECgPX,gBAAA;EACA,eAAA;AAq3BJ;;AAl3BA;EACI,eAAA;EACA,aAAA;EACA,mBAAA;AAq3BJ;AAp3BI;EACI,iBAAA;AAs3BR;AAp3BI;EACI,cAAA;EACA,gBAAA;EACA,gBAAA;EACA,eAAA;AAs3BR;;AAl3BA;EACI,yBAAA;EACA,YAAA;EACA,kBAAA;AAq3BJ;;AAl3BA;EAEI,yBAAA;AAo3BJ;AA72BQ;EACI,0BAAA;EACA,2BAAA;EACA,4BAAA;EACA,kCAAA;EACA,4BAAA;EACA,oCAAA;EACA,qCAAA;EACA,YAAA;AA+2BZ;AA32BY;EACI,kCDpTA;ECqTA,yCAAA;EACA,8BAAA;AA62BhB;AAx2BY;EACI,2BAAA;EACA,2BAAA;EACA,qBAAA;EACA,6CAAA;EACA,2BAAA;AA02BhB;AAv2BY;EACI,kCDpUA;AC6qChB;AAv2BgB;EACI,uBAAA;EACA,4BAAA;AAy2BpB;AAv2BoB;EACI,2BAAA;EACA,wBAAA;EACA,mDAAA;EACA,cAAA;AAy2BxB;AAv2BwB;EACI,WAAA;EACA,qBAAA;AAy2B5B;AAv2B4B;EACI,iBAAA;AAy2BhC;AAt2B4B;EACI,2CAAA;AAw2BhC;AAj2BwB;EACI,wCAAA;AAm2B5B;AAj2B4B;EACI,2CAAA;AAm2BhC;AA31BQ;EACI,aAAA;EACA,mBAAA;EACA,gBAAA;EACA,mBAAA;AA61BZ;AAz1BI;EAYI,0BAAA;EACA,eAAA;EACA,eAAA;EACA,aAAA;EACA,WAAA;EAEA,YAAA;EACA,mBAAA;EACA,oCDlYO;ECmYP,gBAAA;EACA,8BAAA;EACA,iDAAA;EACA,aAAA;AA+0BR;AA70BQ;EACI,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,mBAAA;AA+0BZ;AA50BQ;EACI,8BAAA;AA80BZ;AA30BQ;EACI,gBAAA;EACA,eAAA;EACA,cAAA;EACA,sBAAA;AA60BZ;AA10BQ;EACI,SAAA;EACA,gBAAA;EACA,eAAA;EACA,cAAA;EACA,sBAAA;EACA,mBAAA;EACA,gBAAA;AA40BZ;AAz0BQ;EACI,gBAAA;EACA,eAAA;EACA,cAAA;EACA,sBAAA;EACA,0BAAA;EACA,eAAA;AA20BZ;AAv0BI;EACI,oBAAA;AAy0BR;AAv0BQ;EACI,iBAAA;AAy0BZ;AAt0BQ;EACI,gCAAA;AAw0BZ;AAt0BQ;EACI,gBAAA;AAw0BZ;AA/zBQ;EACI,wBDvcI;ECwcJ,iBAAA;EACA,eAAA;EACA,iBAAA;EACA,sBAAA;EACA,aAAA;EAEA,mBAAA;EACA,8BAAA;AAg0BZ;AA7zBY;EACI,uBDreC;ACoyCjB;AA5zBY;EACI,eAAA;EACA,gBAAA;EAEA,wBDndD;ECqdC,iBAAA;EACA,gBAAA;EACA,sBAAA;AA4zBhB;AA1zBgB;EACI,uBDnfH;AC+yCjB;AAxzBY;EACI,eAAA;EACA,gBAAA;EACA,cAAA;EACA,sBAAA;EACA,gBAAA;EACA,gBAAA;EACA,gBAAA;EACA,kBAAA;AA0zBhB;AAvzBY;EACI,gBAAA;EACA,eAAA;EACA,uBAAA;EACA,WAAA;EACA,gBAAA;EACA,kBAAA;EACA,kBAAA;EACA,yBAAA;AAyzBhB;AAvzBgB;EACI,kCAAA;AAyzBpB;AAtzBgB;EACI,cAAA;EACA,kBAAA;EACA,UAAA;EACA,uBAAA;EACA,YAAA;EACA,aAAA;EACA,0BAAA;AAwzBpB;AAvzBoB;EACI,wBAAA;EACA,SAAA;AAyzBxB;AAnzBY;EACI,gBAAA;EACA,gBAAA;EACA,eAAA;EACA,sBAAA;EACA,cAAA;EACA,yBAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,gBAAA;EACA,WAAA;EACA,gBAAA;AAqzBhB;AAnzBgB;EACI,kCAAA;AAqzBpB;AAlzBgB;EACI,WAAA;EACA,gBAAA;EACA,UAAA;EACA,uBAAA;EACA,YAAA;EACA,aAAA;EACA,0BAAA;AAozBpB;AAnzBoB;EACI,wBAAA;EACA,SAAA;AAqzBxB;AAhzBY;EACI,gBAAA;EACA,gBAAA;EACA,eAAA;EACA,sBAAA;EACA,cAAA;EACA,yBAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,gBAAA;EACA,WAAA;EACA,gBAAA;AAkzBhB;AAjzBgB;EACI,kCAAA;AAmzBpB;AA/yBY;EACI,2BAAA;EACA,0BAAA;EACA,wCAAA;EACA,+CAAA;EACA,4BAAA;EACA,2BAAA;EACA,qCAAA;EACA,2BAAA;EACA,+BAAA;AAizBhB;AA9yBY;EACI,iBAAA;AAgzBhB;AA7yBY;EACI,gBAAA;EACA,0BAAA;EACA,eAAA;EACA,qBAAA;EACA,cAAA;EACA,YAAA;EACA,SAAA;EACA,0BAAA;EACA,iBAAA;AA+yBhB;AA9yBgB;EACI,6BAAA;EACA,SAAA;EACA,0BAAA;AAgzBpB;AAxyBgB;EACI,kBAAA;EACA,mBAAA;AA0yBpB;AAryBQ;EACI,aAAA;EACA,mBAAA;EACA,YAAA;EACA,kBAAA;AAuyBZ;AApyBY;EACI,6BAAA;EACA,YAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,2CAAA;AAsyBhB;AAryBgB;EACI,oCDnmBH;EComBG,sBAAA;AAuyBpB;AAryBoB;EACI,gDAAA;AAuyBxB;AAnyBY;EACI,0CAAA;EACA,kBAAA;EACA,WAAA;EACA,gBAAA;EACA,YAAA;AAqyBhB;AApyBgB;EACI,8CAAA;AAsyBpB;AApyBgB;EACI,qBAAA;AAsyBpB;AApyBgB;EACI,sBAAA;EACA,uBAAA;AAsyBpB;AAryBoB;EACI,QAAA;AAuyBxB;AApyBgB;EACI,aAAA;AAsyBpB;AAlyBY;EACI,6BAAA;EAEA,sBAAA;EACA,YAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,gBAAA;EACA,eAAA;EACA,2CAAA;EACA,8BAAA;EACA,cAAA;AAmyBhB;AAhyBY;EACI,mBAAA;EACA,aAAA;AAkyBhB;AAhyBgB;EACI,cAAA;EACA,cAAA;EACA,iBAAA;EACA,sBAAA;AAkyBpB;AAhyBoB;EACI,kBAAA;EACA,oBAAA;AAkyBxB;;AAxxBA;EACI,aAAA;EACA,mBAAA;EACA,kBAAA;EACA,eAAA;EAEA,gBAAA;AA0xBJ;AAxxBI;EACI,sBAAA;EACA,kBAAA;AA0xBR;AAzxBQ;EACI,mBAAA;EACA,wBDhsBG;ECisBH,gBAAA;AA2xBZ;AAzxBQ;EACI,sBAAA;EACA,wBDrsBG;ECssBH,gBAAA;EACA,0BAAA;AA2xBZ;AAxxBI;EACI,wBD3sBO;EC4sBP,gBAAA;EACA,0BAAA;EACA,eAAA;EACA,eAAA;AA0xBR;AAvxBI;EACI,iBAAA;EACA,eAAA;EACA,iBAAA;EACA,yBAAA;EACA,qBAAA;EACA,gCDruBO;ECsuBP,iBAAA;AAyxBR;AAtxBI;EACI,mBAAA;EACA,eAAA;EACA,iBAAA;EACA,sBAAA;EACA,wBDpvBQ;ECqvBR,mBAAA;AAwxBR;;AApxBA;EACI,aAAA;EACA,mBAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;EACA,mBAAA;AAuxBJ;AApxBQ;EACI,UAAA;AAsxBZ;AAnxBI;EACI,UAAA;AAqxBR;AAhxBQ;EACI,aAAA;AAkxBZ;AA9wBI;EACI,iDAAA;AAgxBR;;AA5wBA;EACI,wCAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,sBAAA;EACA,cAAA;EACA,iBAAA;EACA,mCAAA;EACA,eAAA;AA+wBJ;AA5wBI;EACK,gBAAA;EACA,uBAAA;AA8wBT;AA1wBI;EACI,iDAAA;AA4wBR;;AAxwBA;EACI,eAAA;EACA,YAAA;EACA,UAAA;AA2wBJ;;AAxwBA;EACI,UAAA;EACA,eAAA;EACA,kBAAA;AA2wBJ;;AAxwBA;EACI,WAAA;EACA,yBAAA;EACA,gBAAA;EACA,eAAA;EACA,iCAAA;EACA,kCAAA;EACA,yBAAA;EACA,oCAAA;EACA,6BAAA;EACA,2BAAA;AA2wBJ;;AAxwBA;EACI,YAAA;EACA,eAAA;AA2wBJ;;AAxwBA;EACI,4BAAA;EACA,mBAAA;EACA,mBAAA;AA2wBJ;AAzwBQ;EACI,eAAA;EACA,gBAAA;EACA,kBAAA;AA2wBZ;;AAtwBA;EACI,gBAAA;EACA,yBAAA;EACA,4BAAA;EAEA,kBAAA;AAwwBJ;;AApwBI;EACI,kBAAA;EACA,WAAA;EACA,aAAA;AAuwBR;AAtwBQ;EACI,WAAA;EACA,aAAA;EACA,4BAAA;AAwwBZ;AAvwBY;EACI,uBD73BC;EC83BD,eAAA;EACA,gBAAA;EACA,sBAAA;EACA,eAAA;EACA,kBAAA;AAywBhB;AAvwBY;EACI,aAAA;EACA,8BAAA;EACA,mBAAA;AAywBhB;AAxwBgB;EACI,gBAAA;EACA,eAAA;EACA,SAAA;AA0wBpB;AAxwBgB;EACI,mBAAA;EACA,iBAAA;EACA,yBAAA;EACA,kBAAA;EACA,0BD74BF;EC84BE,sBAAA;EACA,gBAAA;EACA,eAAA;AA0wBpB;AAxwBgB;EACI,qCDn5BF;ECo5BE,gBAAA;EACA,uBD14BJ;EC24BI,gBAAA;EACA,iBAAA;EACA,qCAAA;EACA,oBAAA;EACA,iBAAA;EACA,0BAAA;AA0wBpB;AAzwBoB;EACI,4CAAA;EACA,iCAAA;EACA,sBD13BT;ACqoDf;AAvwBY;EACI,gBAAA;EACA,eAAA;EACA,sBAAA;EACA,wBDv4BD;ECw4BC,mBAAA;AAywBhB;AAvwBY;EACI,aAAA;EACA,eAAA;AAywBhB;;AAnwBI;EACI,kCDx6BQ;ECy6BR,4BAAA;EACA,mBAAA;EACA,aAAA;AAswBR;AArwBQ;EACI,gBAAA;EACA,eAAA;EACA,wBD55BG;ACmqDf;AArwBQ;EACG,wBD75BI;EC85BJ,eAAA;AAuwBX;AApwBY;EACI,oCAAA;EACA,6BAAA;EACA,gBAAA;EACA,eAAA;EACA,mDAAA;AAswBhB;;AAhwBA;EACI,uBDl9Ba;ECm9Bb,eAAA;EACA,gBAAA;EACA,sBAAA;EACA,eAAA;EACA,kBAAA;AAmwBJ;;AAjwBA;EACI,gBAAA;AAowBJ;;AAhwBI;EACI,gBAAA;EACA,4BAAA;EACA,iCDl9BO;ACqtDf;AAlwBQ;EACI,UAAA;AAowBZ;AAlwBgB;EACI,gBAAA;EACA,kBAAA;AAowBpB;AAnwBoB;EACI,gBAAA;EACA,eAAA;AAqwBxB;AApwBwB;EACI,aAAA;EACA,gBAAA;AAswB5B;AApwBwB;EACI,mBAAA;EACA,yBAAA;EACA,cAAA;EACA,iBAAA;EACA,kBAAA;AAswB5B;AAnwBoB;EACI,yBAAA;EACA,oCAAA;EACA,yBAAA;EACA,0BAAA;EACA,iBAAA;EACA,YAAA;EACA,oBAAA;AAqwBxB;AAhwBQ;EACI,gBAAA;EACA,eAAA;EACA,+BDz9BG;AC2tDf;;AA3vBQ;EACI,gBAAA;EACA,eAAA;EACA,sBAAA;EACA,iBAAA;EACA,kBAAA;EACA,0BAAA;EACA,gBAAA;AA8vBZ;AA7vBY;EACI,WAAA;EACA,YAAA;EACA,WAAA;EACA,mBAAA;AA+vBhB;;AAzvBA;EACI,aAAA;AA4vBJ","sourcesContent":["@import url('https://fonts.googleapis.com/css2?family=Roboto:wght@300;400;500;700&display=swap');\n$clr-danger-900: hsla(0, 89%, 48%, 0.19);\n$clr-danger-450: hsla(5, 99%, 64%, 1);\n$clr-danger-400: hsla(5, 100%, 69%, 1);\n$clr-danger-200: hsla(0, 48%, 83%, 1);\n$clr-primary-900: hsla(237, 69%, 40%, 1);\n$clr-primary-700: hsla(237, 69%, 52%, 1);\n$clr-primary-600: hsla(233, 100%, 57%, 1);\n$clr-primary-400: hsla(237, 40%, 67%, 1);\n$clr-primary-300: hsla(237, 46%, 75%, 1);\n$clr-light-350: hsla(0, 0%, 77%, 0.44);\n$clr-light-450: hsla(0, 0%, 85%, 1);\n$clr-light-500: hsla(0, 0%, 88%, 1);\n$clr-light-600: hsla(0, 0%, 92%, 1);\n$clr-light-700: hsla(0, 0%, 100%, 0.43);\n$clr-light-800: hsla(0, 0%, 98%, 0.83);\n$clr-light-850: hsla(0, 0%, 100%, 0.85);\n$clr-light-95: hsla(0, 0%, 95%, 1);\n$clr-light-900: hsla(0, 0%, 100%, 1);\n$clr-black: rgba(0, 0, 0, 1);\n$clr-black-900: hsla(217, 31%, 6%, 1);\n$clr-black-850: hsla(240, 50%, 4%, 0.69);\n$clr-black-500: hsla(217, 31%, 6%, 0.21);\n$clr-black-25: rgba(0, 0, 0, 0.25);\n$clr-dark-900: hsla(217, 24%, 17%, 1);\n$clr-dark-700: hsla(217, 24%, 17%, 0.788);\n$clr-dark-650: hsla(217, 24%, 17%, 0.35);\n$clr-dark-600: hsla(214, 4%, 39%, 1);\n$clr-dark-630: hsla(214, 4%, 39%, 0.63);\n$clr-dark-500: hsla(217, 1%, 50%, 1);\n$clr-dark-450: hsla(210, 1%, 50%, 1);\n$clr-dark-400: hsla(0, 0%, 97%, 0.78);\n$clr-dark-350: hsla(240, 22%, 95%, 0.22);\n$clr-link-900: hsla(240, 91%, 69%, 1);\n$clr-link-700: hsla(240, 91%, 69%, 1);\n$clr-success-400: hsla(113, 49%, 55%, 0.34);\n\n$clr-dark-300: hsla(214, 4%, 31%, 1);\n$clr-dark-250: hsla(180, 20%, 17%, 1);\n$clr-dark-200: hsla(223, 4%, 66%, 1);\n$clr-dark-150: hsla(217, 24%, 17%, 0.79);\n$clr-light-10: hsla(0, 0%, 71%, 1);\n$clr-light-15: hsla(0, 0%, 92%, 0.69);\n$clr-light-20: hsla(214, 4%, 31%, 0.8);\n$clr-light-25: hsla(0, 0%, 77%, 1);\n$clr-light-30: hsla(0, 0%, 98%, 1);\n$clr-light-35: hsla(0, 0%, 75%, 0.28);\n$clr-light-40: hsla(214, 4%, 31%, 0.79);\n$clr-primary-10: hsla(234, 95%, 92%, 0.37);\n$clr-primary-20: hsla(234, 95%, 92%, 1);\n$clr-link-600: hsla(234, 92%, 56%, 1);\n$clr-success: hsla(217, 24%, 17%, 0.93);\n$clr-table: hsla(213, 7%, 76%, 0.08);\n\n\n\n\nhtml,\nbody {\n  height: 100%;\n}\n\n@for $i from 1 through 100 {\n  $size: 1px * $i;\n\n  .font-size-#{$i} {\n      font-size: $size !important;\n  }\n}\n\nbody {\n  margin: 0;\n  font-family: 'roboto' !important;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  background-color: $clr-light-600 !important;\n  color: $clr-dark-900 !important;\n}\n\na {\n  color: $clr-link-700;\n\n  &:hover,\n  &:focus {\n    color: $clr-link-900;\n  }\n\n  &.no-underline {\n    text-decoration: none;\n  }\n}\n\n.cursor-pointer {\n  cursor: pointer;\n}","@import '../../../index.scss';\n\n\n\n\n// .Tabb{\n//     background-color: white;\n// }\n\n.custom_animation_show{\n    #actions-menu{\n        width: 0;\n         .MuiBackdrop-invisible{\n            width: 0 !important;\n        }   \n    }\n}\n\n\n.tile {\n    background: white;\n    width:calc(100%/4);\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    margin-right:1px;\n    span {\n        color: $clr-light-20;\n       \n        \n        line-height: 1.08;\n        padding: 2px 0px;\n        white-space: nowrap;\n        position: relative;\n        &:before {\n          background-color: $clr-primary-600;\n          bottom: -14.8px;\n          content: \"\";\n          height: 2px;\n          left: 0px;\n          opacity: 0;\n          position: absolute;\n          right: 0px;\n          transform-origin: left center;\n          transform: scaleX(0);\n          transition: all 250ms cubic-bezier(0.25, 0.46, 0.45, 0.94) 0s;\n          visibility: hidden;\n          width: auto;\n        }\n    }\n}\n\n\n\n.STILE {\n    .tab{\n        color: $clr-primary-600;\n    }\n    span:before {\n        transform: scaleX(1.1);\n        visibility: visible;\n        opacity: 1 !important;\n      }\n    \n    \n}\n.drawer__container {\n    background-color: $clr-black-850;\n    .header_container{\n        position: relative;\n    }\n\n    .MuiPaper-root {\n        width: 100%;\n        // width: Min(100%, 666px);\n        background-color: #fafafa;\n        .MuiBox-root{\n            z-index: 2;\n        }\n    }\n    .drawer__body .drawer__tabs {\n        display: flex;\n        align-items: center;\n        justify-content: space-between;\n        padding: 0px 72px 0px 35px;\n        border: 1px solid #EDEDED;\n        .tabs__container{\n            width: 40%;\n            background: transparent;\n            height: 100%;\n            margin: 0;\n            padding: 0;\n            display: flex;\n        }\n    }\n    .drawer__body .drawer__tabs span.drawer__tabsOptions {\n        cursor: pointer;\n        font-weight: 400;\n        font-size: 16px;\n    }\n}\n\n\n.drawer__container .drawer__body .drawer__tabs_content {\n    display: none;\n    padding-right: 1rem;\n    max-height: calc(100vh - 11em);\n    overflow-y: auto;\n    scrollbar-width: 0;\n    scrollbar-color: hsla(240, 100%, 34%, 0.29) #fff;\n\n    &::-webkit-scrollbar {\n        // width: 0.25em;\n        // height: 0.25em;\n        width: 0;\n        height: 0;\n        margin-right: -1em;\n        background-color: #fff;\n      }\n      \n      &::-webkit-scrollbar-thumb {\n        background-color: hsla(240, 100%, 34%, 0.29);\n        border-radius: 3px;\n      \n        &:hover {\n            background-color: hsla(240, 100%, 44%, 0.39);\n        }\n      }\n}\n\n\n.drawer__container .drawer__body.drawer__tabs_config_active .drawer__tabs_content.drawer__tabs_configContent, .drawer__tabs_performanceContent {\n    display: block;\n    padding-left: 1px;\n    .indi__error{\n        color: $clr-danger-450;\n        font-size: 12px;\n        font-weight: 300;\n        letter-spacing: 0.15px;\n        margin-top: 5px;\n    }\n    .sticky__header{\n        position: sticky;\n        top: 0;\n        z-index: 1;\n    .cta__header{\n        justify-content: space-between;\n        align-items: flex-start;\n        background: $clr-light-900;\n        padding: 12px 17px 12px 23px;\n        border-radius: 5px;\n        border-bottom: 1px solid #F5F5F5;\n\n        margin-top: 58px;\n        .action_cta{\n            flex: 1;\n            padding-right: 10px;\n            p{\n                margin-bottom: 0;\n                font-weight: 400;\n                font-size: 12px;\n                text-transform: capitalize;\n            }\n            .drawer__body-entity{\n                margin-top: 0;\n            }\n        }\n        .cta__button{\n            .save__btn{\n                background-color: $clr-primary-20;\n                color: $clr-link-600;\n                border: none;\n            }\n            .dynamic__btn{\n                background-color: $clr-primary-600;\n                font-weight: 600;\n                color: $clr-light-900;\n                border: none;\n                margin-right: 6px;\n            }\n            button{\n                font-weight: 500;\n                font-size: 14px;\n                letter-spacing: 0.25px;\n                padding: 2px 36px;\n                border-radius: 5px;\n                text-transform: capitalize;\n                box-shadow: none;\n\n            }\n            button{\n                &:first-child{\n                    margin-right: 17px;\n                }\n            }\n            .setting__btn{\n                width: 34px;\n            }\n            button:disabled,\n            button[disabled]{\n            border: none;\n            background-color: $clr-light-600;\n            color: $clr-light-25;\n            }\n            svg{\n                stroke-width: 0.7px;\n            }\n        }\n    }\n    .date__data{\n        background: $clr-light-900;\n        padding: 12px 17px 12px 23px;\n        border-radius: 5px;\n        justify-content: space-between;\n        .drawer__body__data__label{\n            text-transform: inherit;\n            min-width: auto;\n        }\n        .drawer__body__data__value{\n            color: $clr-dark-200;\n            margin-left: 3px;\n        }\n        .d-flex.left{\n            width: 395px;\n            justify-content: space-between;\n            align-items: center;\n            p{\n                text-transform: capitalize;\n                margin-bottom: 0;\n            }\n            .line{\n                color: $clr-dark-200;\n                width: 1px;\n            }\n        }\n    }\n    }\n}\n\n.drawer__container .drawer__body.drawer__tabs_apiIntegration_active .drawer__tabs_content.drawer__tabs_apiInteContent {\n    display: block;\n    height: 75vh;\n    overflow: hidden;\n    padding-top: 1.5rem;\n}\n\n.drawer__container .drawer__body.drawer__tabs_performance_active .drawer__tabs_content.drawer__tabs_performanceContent {\n    display: block;\n}\n\n\n.input-width-0 {\n    box-sizing: content-box;\n    width: 1ch;\n}\n\n@for $i from 1 through 100 {\n    $width: 1ch * $i;\n\n    .input-width-#{$i} {\n        box-sizing: content-box;\n        width: $width;\n    }\n}\n\n.drawer__header {\n    // background-color: #212936;\n    background-color: hsla(0, 0%, 96%, 1);\n    height: 50px;\n    padding: 0 3rem;\n    color: white;\n\n    &__button__icon svg {\n        font-weight: 900;\n    }\n}\n\n.drawer__body-subtitle {\n    color: $clr-dark-200;\n    font-weight: 400;\n    font-size: 12px;\n}\n\n.drawer__header-close {\n    cursor: pointer;\n    display: flex;\n    align-items: center;\n    svg{\n        margin-right: 9px;\n    }\n    p{\n        color: #233dff;\n        font-weight: 400;\n        margin-bottom: 0;\n        font-size: 16px;\n    }\n}\n\n.drawer__header-btn {\n    background-color: #DC22FF;\n    color: white;\n    border-radius: 4px;\n}\n\n.drawer__body {\n    // background-color: black;\n    background-color: #fafafa;\n    // height: 100%;\n    // padding: 0px 72px 0px 71px;\n\n    &__variations {\n        // max-width: 444px;\n\n        &__allocation-btn {\n            font-size: 12px !important;\n            font-weight: 500 !important;\n            padding: 1px 20px !important;\n            text-transform: inherit !important;\n            border-width: 1px !important;\n            border: 1px solid #D5D9FE !important;\n            color: $clr-primary-600 !important;\n            height: 27px;\n            // min-width: 285px !important;\n            // width: 100%;\n\n            &.active {\n                background-color: $clr-light-900;\n                border-color: $clr-light-900 !important;\n                border-radius: 4px 4px 0px 0px;\n            }\n        }\n\n        &__allocation-menu {\n            & .MuiPaper-root {\n                min-width: 286px !important;\n                box-shadow: none !important;\n                padding-bottom: 0.2em;\n                background-color: $clr-light-900 !important;\n                margin-top: -2px !important;\n            }\n\n            ul {\n                background-color: $clr-light-900;\n\n                .MuiMenuItem-root {\n                    border: none !important;\n                    padding: 0 0.9rem !important;\n\n                    & .innerList {\n                        padding: 0.5em 0 !important;\n                        color: hsla(232, 8%, 64%, 1);\n                        border-bottom: 1px solid hsla(0, 0%, 92%, 1) !important;\n                        font-size: 8px;\n\n                        & .innerWrapper {\n                            width: 100%;\n                            padding: 0 !important;\n\n                            span {\n                                padding-left: 4px;\n                            }\n\n                            &.active {\n                                background-color: hsla(237, 69%, 40%, 0.06);\n                            }\n                        }\n\n                    }\n\n                    &:hover {\n                        .innerList {\n                            background-color: transparent !important;\n\n                            & .innerWrapper {\n                                background-color: hsla(237, 69%, 40%, 0.06);\n                            }\n                        }\n                    }\n                }\n            }\n        }\n\n        .slider__container{\n            display: flex;\n            align-items: center;\n            margin-top: 18px;\n            margin-bottom: 22px;\n        }\n    }\n\n    &__success {\n        // position: absolute;\n        // top: 5.5em;\n        // display: flex;\n        // justify-content: space-between;\n        // align-items: center;\n        // padding: 0 1rem;\n        // margin-left: 3rem;\n        // line-height: 32px;\n        // width: max-content;\n        // border-radius: 20px;\n        // font-size: 10px;\n        padding: 7px 11px 9px 10px;\n        font-size: 12px;\n        position: fixed;\n        bottom: 1.5000em;\n        left: 2.5000em;\n\n        width: 322px;\n        word-break: inherit;\n        background-color: $clr-dark-900;\n        border-radius: 0;\n        border-left: 4px solid #00B481;\n        box-shadow: 0px 4px 4px rgba(196, 196, 196, 0.57);\n        z-index: 1400;\n\n        .header__msg{\n            display: flex;\n            align-items: center;\n            justify-content: space-between;\n            margin-bottom: 15px;\n        }\n\n        &.error {\n            border-left: 4px solid #E10000;\n        }\n\n        .success_icon_msg {\n            font-weight: 700;\n            font-size: 12px;\n            color: #FDFDFD;\n            letter-spacing: 0.15px;\n        }\n\n        .success-msg{\n            margin: 0;\n            font-weight: 300;\n            font-size: 12px;\n            color: #FDFDFD;\n            letter-spacing: 0.15px;\n            margin-bottom: 13px;\n            overflow: hidden;\n        }\n\n        .success-close {\n            font-weight: 400;\n            font-size: 12px;\n            color: #FDFDFD;\n            letter-spacing: 0.15px;\n            text-decoration: underline;\n            cursor: pointer;\n        }\n    }\n\n    &__entity.bottom__field{\n        padding-bottom: 18px;\n        \n        &:last-child{\n            padding-bottom: 0;\n        }\n        \n        &:not(:last-child){\n            border-bottom: 1px solid #E9E9E9;\n        }\n        &:not(:first-child){\n            margin-top: 18px;\n        }\n    }\n        \n\n    &__entity {\n        // margin-top: 1em;\n        // margin-bottom: 1em;\n      \n        &__title {\n            color: $clr-black-900;\n            font-weight: bold;\n            font-size: 11px;\n            line-height: 24px;\n            letter-spacing: 0.15px;\n            display: flex;\n            // justify-content: space-between;\n            align-items: center;\n            justify-content: space-between;        \n            // background-color: #F3F3F6;\n\n            &.error {\n                color: $clr-danger-450;\n            }\n\n            &__label{\n                font-size:12px;\n                font-weight: 700;\n                // background:#EAEAEA;\n                color: $clr-dark-600;\n                // padding: 0 1rem;\n                min-width: 4.5rem;\n                text-align: left;\n                letter-spacing: 0.15px;\n\n                &.error {\n                    color: $clr-danger-450;\n                }\n\n            }\n            &__id{\n                font-size: 12px;\n                font-weight: 700;\n                color: #a5a7ac;\n                padding: 0 19px 0 27px;\n                text-align: left;\n                max-width: 127px;\n                min-width: 127px;\n                text-align: center;\n            }\n\n            &__traffic{\n                font-weight: 400;\n                font-size: 11px;\n                background:transparent;\n                color:#000;\n                min-width: 105px;\n                text-align: center;\n                border-radius: 5px;\n                border: 1px solid #ECECED;\n\n                &.error__input__variation{\n                    border: 1px solid $clr-danger-450;\n                }\n\n                &__input{\n                    width: 1.75rem;\n                    text-align: center;\n                    padding: 0;\n                    background: transparent;\n                    border: none;\n                    outline: none;\n                    -moz-appearance: textfield;\n                    &::-webkit-inner-spin-button {\n                        -webkit-appearance: none;\n                        margin: 0;\n                    }\n                }\n\n            }\n\n            &__desc {\n                padding: 0px 8px;\n                font-weight: 400;\n                font-size: 11px;\n                letter-spacing: 0.15px;\n                color: #AFB1B6;\n                border: 1px solid #ECECED;\n                border-radius: 5px;\n                max-width: 544px;\n                white-space: nowrap;\n                margin-left: 8px;\n                width: 100%;\n                overflow: hidden;\n\n                &.error__input__variation{\n                    border: 1px solid $clr-danger-450;\n                }\n\n                &__input{\n                    width: 100%;\n                    text-align: left;\n                    padding: 0;\n                    background: transparent;\n                    border: none;\n                    outline: none;\n                    -moz-appearance: textfield;\n                    &::-webkit-inner-spin-button {\n                        -webkit-appearance: none;\n                        margin: 0;\n                    }\n                }\n\n            }\n            &__json{\n                padding: 0px 8px;\n                font-weight: 400;\n                font-size: 11px;\n                letter-spacing: 0.15px;\n                color: #AFB1B6;\n                border: 1px solid #ECECED;\n                border-radius: 5px;\n                max-width: 544px;\n                white-space: nowrap;\n                margin-left: 8px;\n                width: 100%;\n                overflow: hidden;\n                &.error{\n                    border: 1px solid $clr-danger-450;\n                }\n            }\n\n            &__jsonBtn{\n                font-weight: 500 !important;\n                font-size: 12px !important;\n                background-color: transparent !important;\n                border: 1px solid $clr-primary-20 !important;\n                padding: 0px 25px !important;\n                box-shadow: none !important;\n                color: $clr-primary-600 !important;\n                margin-left: 8px !important;\n                line-height: inherit !important;\n            }\n\n            &__copyBtn{\n                margin-left: 14px;\n            }\n\n            .delete__btn{\n                font-weight: 400;\n                text-transform: capitalize;\n                font-size: 12px;\n                padding: 0 !important;\n                line-height: 1;\n                min-width: 0;\n                border: 0;\n                text-decoration: underline;\n                margin-left: 16px;\n                &:hover{\n                    background-color: transparent;\n                    border: 0;\n                    text-decoration: underline;\n                }\n            }\n\n            span {\n                // color: $clr-dark-650;\n                // margin-inline: 1em;\n\n                text {\n                    margin-left: 0.5em;\n                    margin-right: 0.5em;\n                }\n            }\n        }\n\n        &__form {\n            display: flex;\n            align-items: center;\n            flex-grow: 1;\n            margin-right: 21px;\n            // margin-top: 0.25rem;\n\n            &__control {\n                background-color: transparent;\n                height: 27px;\n                flex-grow: 1;\n                width: 414px;\n                padding-left: 10px;\n                padding-right: 7px;\n                display: flex;\n                align-items: center;\n                border-radius: 5px 0px 0px 5px;\n                border: 1px solid rgba(140, 145, 152, 0.13);\n                .MuiSlider-colorPrimary{\n                    background-color: $clr-primary-20;\n                    background-image: none;\n                }\n                    .MuiSlider-thumbColorPrimary{\n                        background-color: $clr-primary-600 !important;\n                }\n            }\n\n            &__code {\n                border: 2px solid $clr-dark-630;\n                border-radius: 4px;\n                width: 100%;\n                resize: vertical;\n                height: 100%;\n                &.error {\n                    border: 2px solid $clr-danger-400 !important;\n                }\n                .ace_scrollbar{\n                    width: 5px !important;\n                }\n                .ace_editor{\n                    width: 100% !important;\n                    height: 100% !important;\n                    .ace_print-margin{\n                        width: 0;\n                    }\n                }\n                .ace-xcode .ace_print-margin{\n                    display: none;\n                }\n            }\n\n            &__label {\n                background-color: transparent;\n                // line-height: 14px;\n                letter-spacing: 0.15px;\n                height: 27px;\n                min-width: 106px;\n                display: flex;\n                align-items: center;\n                justify-content: center;\n                font-weight: 500;\n                font-size: 11px;\n                border: 1px solid rgba(140, 145, 152, 0.13);\n                border-radius: 0px 5px 5px 0px;\n                line-height: 0;\n            }\n\n            &__button {\n                margin-left: 0.15em;\n                display: flex;\n\n                button {\n                    padding: 0.3em;\n                    font-size: 8px;\n                    line-height: 16px;\n                    letter-spacing: 0.25px;\n\n                    &.hide {\n                        visibility: hidden;\n                        pointer-events: none;\n                    }\n                }\n\n            }\n        }\n    }\n}\n\n\n.drawer__body__data {\n    display: flex;\n    align-items: center;\n    margin-right: 1rem;\n    min-width: 9rem;\n\n    overflow: hidden;\n\n    &.gate_id{\n        min-width: fit-content;\n        margin-right: 18px;\n        .drawer__body__data__value{\n            margin-left: 0.2rem;\n            color: $clr-dark-200;\n            font-weight: 700;\n        }\n        .drawer__body__data__label{\n            min-width: min-content;\n            color: $clr-dark-200;\n            font-weight: 700;\n            text-transform: capitalize;\n        }\n    }\n    &.api_integration{\n        color: $clr-dark-200;\n        font-weight: 400;\n        text-decoration: underline;\n        font-size: 12px;\n        cursor: pointer;\n    }\n\n    &__label {\n        font-weight: bold;\n        font-size: 12px;\n        line-height: 16px;\n        text-transform: uppercase;\n        letter-spacing: 0.4px;\n        color: $clr-dark-650;\n        min-width: 4.5rem;\n    }\n\n    &__value {\n        font-weight: normal;\n        font-size: 12px;\n        line-height: 30px;\n        letter-spacing: 0.15px;\n        color: $clr-black-900;\n        margin-left: 0.5rem;\n    }\n}\n\n.drawer__body-entity {\n    display: flex;\n    align-items: center;\n    border: none;\n    border-radius: 5px;\n    margin-top: 2px;\n    padding-right: 10px;\n    // width:min-content !important;\n    &:hover{\n        svg{\n            opacity: 1;\n        }\n    }\n    svg{\n        opacity: 0;\n    }\n    &:focus-within {\n        // box-shadow: 0 0 0.05rem 0.05rem $clr-primary-300;\n\n        svg {\n            display: none;\n        }\n    }\n\n    &.error {\n        box-shadow: 0 0 0.05rem 0.05rem $clr-danger-400;\n    }\n}\n\n.drawer__body-input {\n    background-color: transparent !important;\n    border: none;\n    border-radius: 5px;\n    font-size: 20px;\n    font-weight: 700;\n    letter-spacing: 0.15px;\n    padding-top: 0;\n    padding-bottom: 0;\n    color: $clr-dark-300 !important;\n    padding-left: 0;\n    // width: 100px;\n\n    &:focus {\n         box-shadow: none;\n         border: none !important;\n        // box-shadow: none;\n    }\n\n    &.error {\n        box-shadow: 0 0 0.05rem 0.05rem $clr-danger-400;\n    }\n}\n\n.drawer__body-entity_title_inner {\n    font-size: 10px;\n    color: white;\n    opacity: 1;\n}\n\n.drawer__error {\n    color: red;\n    font-size: 12px;\n    text-align: center;\n}\n\n.drawer__body-variation_btn {\n    width: 100%;\n    color: #A4A6AB !important;\n    font-weight: 500;\n    font-size: 14px;\n    letter-spacing: 0.25px !important;\n    text-transform: inherit !important;\n    padding: 6px 0 !important;\n    background-color: #Fafafa !important;\n    border-color: none !important;\n    box-shadow: none !important;\n}\n\n.drawer__body-remove_btn {\n    color: white;\n    font-size: 10px;\n}\n\n.drawer__body-container{\n    padding: 22px 47px 64px 25px;\n    background: #ffffff;\n    border-radius: 10px;\n    .drawer{\n        &__body-title{\n            font-size: 15px;\n            font-weight: 400;\n            margin-bottom: 9px;\n        }\n    }\n}\n\n.drawer_body__entity__container{\n    margin-top: 26px;\n    border: 1px solid #E9E9E9;\n    padding: 18px 36px 21px 11px;\n\n    border-radius: 5px;\n}\n\n.jsonForm-dialog{\n    .MuiPaper-root{\n        max-width: inherit;\n        width: 100%;\n        height: 637px;\n        .jsonForm__content{\n            width: 100%;\n            height: 637px;\n            padding: 18px 32px 30px 40px;\n            .indi__error{\n                color: $clr-danger-450;\n                font-size: 12px;\n                font-weight: 300;\n                letter-spacing: 0.15px;\n                margin-top: 5px;\n                margin-bottom: 8px;\n            }\n            .jsonPopUp__header{\n                display: flex;\n                justify-content: space-between;\n                align-items: center;\n                p{\n                    font-weight: 600;\n                    font-size: 15px;\n                    margin: 0;\n                }\n                button{\n                    background: #ffffff;\n                    padding: 1px 34px;\n                    border: 1px solid #d5d9fe;\n                    border-radius: 5px;\n                    color: $clr-primary-600;\n                    letter-spacing: 0.25px;\n                    font-weight: 500;\n                    font-size: 14px;\n                }\n                .save__btn{\n                    background-color: $clr-primary-600;\n                    font-weight: 600;\n                    color: $clr-light-900;\n                    box-shadow: none;\n                    padding: 1px 34px;\n                    border: 1px solid $clr-primary-600;\n                    line-height: inherit;\n                    margin-left: 12px;\n                    text-transform: capitalize;\n                    &.Mui-disabled{\n                        background-color: $clr-light-600 !important;\n                        border: 1px solid $clr-light-600;\n                        color: $clr-light-25;\n                    }\n                }\n            }\n            .json__subtitle{\n                font-weight: 400;\n                font-size: 12px;\n                letter-spacing: 0.25px;\n                color: $clr-dark-200;\n                margin-bottom: 14px;\n            }\n            .drawer__body__entity__form{\n                height: 517px;\n                margin-right: 0;\n            }\n        }\n    }\n}\n.drawer__tabs_performanceContent{   \n    .performance__footer__container{\n        background-color: $clr-light-900;\n        padding: 29px 21px 16px 22px;\n        border-radius: 10px;\n        height: 600px;\n        .drawer__body-title{\n            font-weight: 400;\n            font-size: 15px;\n            color: $clr-dark-300;\n        }\n        .drawer__body-subtitle{\n           color: $clr-dark-200;\n           margin-top: 9px;\n        }\n        .drawer__footer{\n            .e-input-group.e-control-wrapper{\n                background-color: #F9F9FA !important;\n                border-radius: 4px !important;\n                font-weight: 400;\n                font-size: 12px;\n                border: 1px solid $clr-light-35 !important;\n            } \n        }\n    }\n}\n\n.indi__error{\n    color: $clr-danger-450;\n    font-size: 12px;\n    font-weight: 300;\n    letter-spacing: 0.15px;\n    margin-top: 5px;\n    margin-bottom: 8px;\n}\n.indi__error.variation{\n    margin-bottom: 0;\n}\n\n.confirmSave_popup{\n    .MuiPaper-root{\n        max-width: 488px;\n        padding: 40px 29px 30px 28px;\n        background-color: $clr-light-95;\n        .confirm__save__content{\n            padding: 0;\n            .confirm__save{\n                .confirmSave__cta{\n                    margin-top: 34px;\n                    text-align: center;\n                    button{\n                        font-weight: 600;\n                        font-size: 14px;\n                        &:focus{\n                            outline: none;\n                            box-shadow: none;\n                        }\n                        &:first-child{\n                            background: #ffffff;\n                            border : 1px solid #D5D9FE;\n                            color:#233dff;\n                            padding: 4px 36px;\n                            margin-right: 13px;\n                        }\n                    }\n                    .save__btn{\n                        background-color: #233dff; \n                        border: 1px solid #233dff !important; \n                        color:#ffffff !important; \n                        text-transform: capitalize; \n                        padding: 3px 40px; \n                        height:100%;\n                        line-height: inherit;\n                    }\n                }\n            }\n        }\n        p{\n            font-weight: 500;\n            font-size: 20px;\n            color: $clr-light-40;\n        }\n    }\n}\n\n.drawer__body.drawer__tabs_performance_active{\n    .cta__button{\n        button{\n            font-weight: 500;\n            font-size: 14px;\n            letter-spacing: 0.25px;\n            padding: 2px 36px;\n            border-radius: 5px;\n            text-transform: capitalize;\n            box-shadow: none;\n            svg.dots{\n                width: 15px;\n                height: 26px;\n                fill: black;\n                stroke-width: 1.5px;\n            }\n        }\n    }\n}\n\n.archive__msg, .archiveBlank__msg{\n    display: none;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
